export const lang = {
  common: {
    play: 'Chơi',
    viewMore: 'Xem thêm',
    currency: 'Tiền tệ',
    fail: 'Thất bạiu',
    success: 'Thành công',
    downLoad: 'Tải xuống',
    next: 'Tiếp theo',
    finish: 'Kết thúc',
    cancel: 'Hủy',
    login: 'Đăng nhập',
    ok: 'OK',
    errorPrompt: 'Một lỗi đã xảy ra. Vui lòng thử lại hoặc liên hệ với bộ phận hỗ trợ của chúng tôi.',
    submit: 'Nộp'
  },
  menu: {
    Home: 'Nhà',
    Games: 'Trò chơi',
    Promotion: 'Khuyến mãi',
    FAQ: 'Câu hỏi thường gặp',
    Deposit: 'Gửi tiền',
    Withdraw: 'Rút',
    Account: 'Tài khoản',
    Edit: 'Chỉnh sửa thông tin',
    History: 'Lịch sử',
    Message: 'Tin nhắn',
    Support: 'Hỗ trợ',
    Terms: 'Các điều khoản và điều kiện',
    Privacy: 'Chính sách bảo mật',
    Responsible: 'Cờ bạc có trách nhiệm',
    Affiliate: 'Chi nhánh',
    Login: 'Đăng nhập',
    Logout: 'Đăng xuất',
    AboutUs: 'Về chúng tôi',
    News: 'Tin tức',
    Kyc: 'KYC chính sách'
  },
  footer: {
    Home: 'Nhà',
    Events: 'Sự kiện',
    Promotion: 'Khuyến mãi',
    Deposit: 'Tiền gửi',
    Withdraw: 'Rút'
  },
  label: {
    POPULAR: 'PHỔ BIẾN NHẤT',
    CASINO: 'CASINO TRỰC TIẾP',
    LOTTERY: 'VÉ SỐ',
    FISHING: 'TRÒ CHƠI CÂU CÁ',
    SLOTS: 'CHỖ',
    hot: 'NÓNG',
    live: 'Đại lý trực tiếp',
    lottery: 'Vé số',
    fishing: 'Câu cá',
    slots: 'Chỗ',
    sports: 'Thể thao',
    casino: 'casino'
  },
  promotion: {
    title1: '100% TIỀN THƯỞNG',
    desc1_1: 'Nhận 100% tiền thưởng cho khoản tiền gửi của bạn!',
    desc1_2: '<div style="text-align: center; display: block; width: 100%">Đặt lương 40X</div>',
    desc1_3: '<div style="text-align: center; display: block; width: 100%">Chỉ sử dụng một lần | Không có giới hạn tiền gửi</div>',
    title2: '# Tháng tăng hiện tại # Điên cuồng',
    desc2_1: '₹ 2,5 triệu mỗi người dành cho Top 3 Người chiến thắng hàng ngày lớn nhất trong #Tháng bình thường hiện tại#',
    desc2_2: 'Thanh toán ngay lập tức vào #Ngày cuối cùng của tháng hiện tại#',
    title3: 'Tiền thưởng 10 ngày Diwali',
    desc3_1: 'Chúc mừng Diwali 2021',
    desc3_2: 'Tiền thưởng 150% cho mỗi khoản tiền gửi bạn thực hiện từ ngày 4 tháng 11 đến ngày 17 tháng 11',
    title4: 'Mời và kiếm ₹',
    desc4_1: '①<div style="margin-left: 10px;flex: 1;text-align: left;">Nhận ngay ₹ 10 khi mời mỗi người bạn đăng ký và chơi.</div>',
    desc4_2: '②<div style="margin-left: 10px;flex: 1;text-align: left;">Nhận 5% trên mỗi khoản tiền gửi mà bạn của bạn thực hiện và 500 yên khác nếu tổng số tiền gửi của anh ấy / cô ấy trên 10.000 yên</div>',
    desc4_3: '③<div style="margin-left: 10px;flex: 1;text-align: left;">Tổng phần thưởng lên đến ₹ 100 Triệu!</div>',
    title5: '10 người chiến thắng lớn trong tháng',
    desc5_1: 'Trong thời gian khuyến mãi, 10 người chơi giành chiến thắng nhiều nhất sẽ có thể chia sẻ phần thưởng tiền mặt hơn 10 triệu rupee!',
    title6: 'Trực tuyến và kiếm tiền mặt',
    desc6_1: 'Ở trên ứng dụng PGEbet hơn 1 giờ mỗi ngày trong 7 ngày liên tiếp để giành được 100 rupee.',
    promotionDuration: 'Thời lượng Khuyến mại:',
    duration1: '1 tháng',
    title7: 'Khuyến mãi thể thao năm 2021',
    desc7_1: 'Sử dụng 100% tiền thưởng tiền gửi của bạn!',
    desc7_2: 'Không có giới hạn tiền gửi đối với tất cả các môn thể thao bao gồm cả trò chơi Bóng đá và Cricket!',
    title8: 'Ngày lễ Giáng sinh đặc biệt',
    desc8_1: 'Nhận Quà tặng PGE của bạn cho tháng 12!',
    desc8_2: 'Gửi tiền trong tháng 12 sẽ nhận được 150% tiền thưởng. Kết thúc đêm Giáng sinh.',
    button_text8: 'Gửi tiền ngay bây giờ',
    button_nav8: 'Gửi tiền',
    title9: 'Tiền thưởng câu lạc bộ VIP',
    desc9_1: 'Tham gia Câu lạc bộ VIP và nhận Tiền thưởng cho mỗi lần gửi tiền!',
    desc9_2: '100% tiền thưởng cho thành viên VIP',
    desc9_3: 'Tiền thưởng 150% cho các thành viên SVIP',
    button_text9: 'Tham gia câu lạc bộ VIP',
    button_nav9: 'VIP'
  },
  notice: {
    title1: 'Blackjack - Trò chơi vui nhộn của 21',
    subTitle1: 'Kiếm được số tiền lớn ngay hôm nay!',
    text1_1: 'Trò chơi nhanh chóng được chơi mỗi phút. Dễ chơi và có thể sử dụng tất cả các Khuyến mãi tiền thưởng.',
    title2: 'Baccarat - Rất dễ chơi!',
    subTitle2: 'Đặt cược vào Nhà cái hoặc Người chơi',
    text2_1: 'Các trò chơi nhanh chóng và tất cả các Khuyến mãi Tiền thưởng đều có thể được sử dụng.',
    title3: 'Roulette - Thật thú vị!',
    subTitle3: 'Dễ dàng chơi và chơi trên khắp thế giới.',
    text3_1: 'Nếu quả bóng rơi vào số của bạn, bạn sẽ thắng gấp 35 lần tiền đặt cược!',
    title4: 'Cá cược thể thao 24/7',
    subTitle4: 'Cũng có thể \'Bán Cược của bạn \'. Chơi để tìm hiểu thêm!\n',
    text4_1: 'Bao gồm cricket, bóng đá và các môn thể thao trên khắp thế giới.',
    title5: 'Hướng dẫn chơi Roulette',
    subTitle5: 'Xem video này và học cách chơi. Dễ dàng và thú vị.',
    text5_1: 'Nếu quả bóng rơi vào số của bạn, bạn sẽ thắng gấp 35 lần tiền đặt cược!',
    titleAndar: 'Cuộc thi Andar Bahar',
    subTitleAndar: 'Chơi Andar Bahar Trực tiếp và Giành giải thưởng ₹ 1 triệu hàng tháng!',
    textAndar_1: 'Cuộc thi bắt đầu vào ngày 1 tháng 3 năm 2022! Giữ nguyên!',
    buttonAndar: 'Xếp hạng của tôi',
    titleBlackjack: 'Hướng dẫn chơi Blackjack',
    subTitleBlackjack: 'Một trong những trò chơi sòng bạc phổ biến nhất trên thế giới.',
    textBlackjack: 'Chỉ cần đánh bại các đại lý và bạn giành chiến thắng! Dễ học và thú vị để chơi.'
  },
  winner: {
    justWon: 'vừa thắng',
    playing: 'đang chơi',
    live: 'trực tiếp',
    players: 'người chơi'
  },
  login: {
    login: 'Đăng nhập',
    register: 'Đăng ký',
    recover: 'Khôi phục mật khẩu',
    reset: 'Đặt lại mật khẩu',
    email: 'Email',
    password: 'Mật khẩu',
    continue: 'hoặc tiếp tục với',
    forget: 'Quên mật khẩu',
    username: 'Tên tài khoản',
    Username: 'Tên tài khoản',
    invalid: 'Số điện thoại di động không hợp lệ',
    depositCur: 'Tiền gửi hiện tại',
    Recover: 'Bình phục',
    Reset: 'Cài lại',
    Submit: 'Nộp',
    mobileNumber: 'Số điện thoại',
    snsPrompt1: 'Mã đã được gửi đến',
    snsPrompt2: 'Vui lòng nhập mã để đăng nhập.',
    incorrectCode: 'Mã không chính xác',
    resendCode: 'Mã gửi lại',
    abnormalPrompt1: 'Tài khoản của bạn đã bị tạm ngưng do các hoạt động bất thường. Xin vui lòng liên hệ',
    abnormalPrompt2: 'hoặc',
    abnormalPrompt3: 'Hỗ trợ trực tuyến',
    abnormalPrompt4: 'Nếu bạn có câu hỏi nào.',
    codeExpired: 'Mã đã hết hạn',
    newPassword: 'Mật khẩu mới',
    couponCode: 'Mã phiếu giảm giá (tùy chọn)'
  },
  message: {
    emailActivate: 'Xảy ra lỗi khi kích hoạt email',
    inputEmail: 'Vui lòng nhập email',
    inputPassword: 'Vui lòng nhập mật khẩu',
    inputUsername: 'Vui lòng nhập tên người dùng',
    inputValid: 'Vui lòng nhập địa chỉ email hợp lệ',
    passwordMust: 'Mật khẩu phải từ 8-18 ký tự và bao gồm số, bảng chữ cái và ký tự đặc biệt',
    notRegister: 'Email này không được đăng ký',
    notCorrect: 'Mật khẩu không đúng',
    registerSuccess: 'Đăng ký thành công',
    usernameExit: 'Tên người dùng đã tồn tại',
    emailExit: 'Email đã tồn tại',
    mobileExit: 'Di động đã tồn tại',
    accountSuspended: 'Tài khoản của bạn đã bị tạm ngưng do các hoạt động bất thường. Vui lòng liên hệ support@pgebet.com',
    registerFail: 'Thất bại. Vui lòng thử lại hoặc liên hệ với support@pgebet.com'
  },
  active: {
    emailActive: 'Email đang hoạt động',
    activating: 'Kích hoạt email của bạn'
  },
  account: {
    totalBalance: 'Tổng số dư',
    cash: 'Tiền mặt',
    safe: 'An toàn',
    safeWallet: 'Ví an toàn',
    deposit: 'Gửi tiền',
    transfer: 'Chuyển giao',
    transferTo: 'Chuyển đến',
    safeBalance: 'Số dư an toàn',
    safeOnlyForDeposit: 'Tính năng an toàn chỉ khả dụng cho khách hàng đã ký gửi',
    inputAmount: 'Nhập số tiền cần chuyển',
    giftAmount: 'Số tiền quà tặng',
    transferExceedLimit: 'Số tiền chuyển vượt quá giới hạn: ',
    transferSuccess: 'Chuyển giao thành công',
    transferFail: 'Chuyển không thành công',
    transferError: 'Chuyển lỗi',
    withdraw: 'Rút',
    affiliate: 'Chi nhánh',
    bonus: 'Tặng thêm',
    completedBonus: 'Tiền thưởng đã hoàn thành',
    claim: 'Yêu cầu',
    invite: 'Liên kết mời',
    copy: 'Sao chép đường dẫn',
    cashBalance: 'Số dư tiền mặt',
    apply: 'Nhận',
    depositBonus: 'Tiền thưởng khi gửi tiền',
    agree: 'Tôi đồng ý với các điều khoản và điều kiện',
    submit: 'Nộp',
    amount: 'Số lượng',
    selectAmount: 'Vui lòng chọn một số tiền',
    withdrawalRules: 'Quy tắc rút tiền',
    withdrawalRuleList:
    '<div style="margin: 12px 0">① Bạn phải đặt cược số tiền Gửi của mình ít nhất một lần trước khi bạn có thể Rút tiền. Ví dụ: Gửi 500 và thực hiện hai cược 250, sau đó Rút tiền.</div>' +
    '<div style="margin: 12px 0">② Phí rút tiền là 18%.</div>' +
    '<div style="margin: 12px 0 30px 0">③ Bạn có thể gửi tối đa 5 lần Rút tiền mỗi ngày.</div>',
    wallet: 'Ví của tôi',
    accountName: 'Tên tài khoản',
    accountNo: 'Số tài khoản',
    IFSC: 'Mã ngân hàng (Mã IFSC)',
    check: 'Kiểm tra thỏa thuận',
    outRange: 'Số tiền không hợp lệ, nằm ngoài phạm vi',
    notEnough: 'Không có đủ số dư',
    copySuccess: 'Sao chép thành công',
    gateway: 'Cổng vào',
    withdrawableBalance: 'Số dư có thể rút',
    notWithdrawable: 'không thể rút được',
    yourID: 'ID của bạn',
    upload: 'Tải lên',
    view: 'Xem',
    bankAccount: 'Tài khoản ngân hàng',
    rules: 'Luật',
    myRewards: 'Giải thưởng của tôi',
    friends: 'Bạn bè',
    total: 'Tổng',
    rewards: 'Giải thưởng',
    shareLink: 'Chia sẻ liên kết để kiếm tiền',
    shareRuleTitle1: 'Nhận ₹ 10 tiền mặt',
    shareRuleDescription1: 'Sau khi bạn của bạn đăng ký và hoàn thành 3 lần đặt cược.',
    shareRuleTitle2: 'Nhận 5% số tiền gửi của bạn bè',
    shareRuleDescription2: '5% tiền mặt ngay lập tức sau mỗi lần gửi tiền mà bạn của bạn thực hiện. ₹ 500 khác sau khi tổng số tiền gửi của mỗi người bạn của bạn đạt hơn ₹ 10.000!',
    shareRuleTitle3: 'Kiếm tiền mặt không giới hạn',
    shareRuleDescription3: 'Bạn mời càng nhiều bạn bè và bạn bè gửi càng nhiều, bạn càng kiếm được nhiều tiền. Không giới hạn!',
    noRewardSharePrompt: 'Chưa có phần thưởng? Chia sẻ liên kết bên dưới để kiếm tiền hoa hồng của bạn ngay bây giờ!',
    joined: 'Đã tham gia',
    inviteRewards: 'phần thưởng mời',
    depositRewards: 'Phần thưởng khi gửi tiền',
    lastPlayed: 'Lần chơi cuối',
    lastDeposit: 'Khoản tiền gửi cuối cùng',
    whatsapp: 'Whatsapp',
    selectDepositAmount: 'Vui lòng chọn số tiền gửi',
    selectUPIChannel: 'Vui lòng chọn kênh UPI',
    needLogin: 'Vui lòng đăng nhập trước tiên',
    promptToSetID: 'Vui lòng thiết lập id của bạn trước khi rút tiền',
    promptToSubmitID: 'Vui lòng gửi id của bạn trước khi rút tiền',
    promptToSubmitBankAccount: 'Vui lòng gửi tài khoản ngân hàng của bạn trước khi rút tiền',
    selectWithdrawAmount: 'Vui lòng chọn số tiền rút',
    withdrawSetup: {
      personalInfo: 'Thông tin cá nhân',
      idDocument: 'Tài liệu ID',
      textPromptToUpgrade: 'Nếu bạn gặp sự cố khi tải ảnh lên, vui lòng nhấn để sao chép và dán liên kết bên dưới vào trình duyệt của bạn để tải xuống và cài đặt phiên bản mới nhất của ứng dụng.',
      copyLnk: 'Sao chép liên kết',
      textFrontSide: 'Mặt trước thẻ Aadhaar của bạn',
      textBackSide: 'Mặt sau thẻ Aadhaar của bạn',
      textPhoto: 'Ảnh của chính bạn đang cầm thẻ Aadhaar',
      textFullName: 'Tên đầy đủ',
      textCardNumber: 'Số thẻ Aadhaar',
      textMobileNumber: 'Số điện thoại',
      textYourBank: 'Tài khoản ngân hàng của bạn',
      promptFillName: 'Vui lòng điền tên đầy đủ của bạn',
      promptFillCard: 'Vui lòng điền số thẻ Aadhaar của bạn',
      promptCardInvalid: 'Số thẻ Aadhaar không hợp lệ',
      promptUploadFrontCard: 'Vui lòng tải lên mặt trước thẻ Aadhaar của bạn',
      promptUploadBackCard: 'Vui lòng tải lên mặt sau thẻ Aadhaar của bạn',
      promptUploadPhoto: 'Vui lòng tải ảnh lên với chính bạn đang cầm thẻ Aadhaar của bạn',
      errorUpload: 'Đã xảy ra lỗi khi tải lên. Vui lòng thử lại',
      promptInvalidCard: 'Mã ngân hàng (mã IFSC) không hợp lệ',
      promptInvalidAccount: 'Số tài khoản không hợp lệ',
      promptFillAccountName: 'Vui lòng điền tên tài khoản',
      promptFillAccountNumber: 'Vui lòng điền số tài khoản',
      promptFillIFSC: 'Vui lòng điền mã ngân hàng (mã IFSC)'
    },
    claimAmount: 'Sô lượng yêu cầu',
    vip: {
      vip: 'VIP',
      svip: 'SVIP',
      myVipStatus: 'Trạng thái VIP của tôi',
      vipRules: 'Luật',
      currentVIPStatus: 'Trạng thái VIP hiện tại của tôi',
      offer: 'ĐỀ NGHỊ',
      bonus: 'TẶNG THÊM',
      everyDeposit: 'MỌI TIỀN GỬI',
      condition: 'ĐIỀU KIỆN',
      singleDeposit: 'Gửi tiền một lần',
      monthlyDeposit: 'Gửi tiền theo tháng',
      deposit: 'Tiền gửi',
      or: 'HOẶC',
      vipPrompt: 'Trở thành VIP để nhận tiền thưởng lớn',
      rules: [
        'Khi trở thành thành viên VIP của PGEbet, bạn sẽ nhận được 100% tiền thưởng cho mỗi lần nạp tiền!',
        'Khi bạn trở thành thành viên PGEbet SVIP (Siêu VIP), bạn sẽ nhận được 150% tiền thưởng cho mỗi lần gửi tiền bạn thực hiện!',
        'Gửi một lần duy nhất trên 5.000 yên hoặc gửi tổng cộng 20.000 yên cho tháng hiện tại để trở thành VIP ngay lập tức. Bạn sẽ nhận được tiền thưởng ngay lập tức từ lần gửi tiền cuối cùng của mình.',
        'Thực hiện một khoản tiền gửi duy nhất trên 10.000 yên hoặc đặt cọc trên tổng số 50.000 yên cho tháng hiện tại để trở thành SVIP ngay lập tức. Bạn sẽ nhận được tiền thưởng ngay lập tức từ lần gửi tiền cuối cùng của mình.',
        'Tư cách thành viên VIP / SVIP của bạn sẽ hết hạn vào ngày cuối cùng của mỗi tháng. Thực hiện các khoản tiền gửi bắt buộc của bạn vào đầu tháng tiếp theo để trở thành VIP / SVIP một lần nữa.'
      ]
    },
    noBonusReadyForClaim: 'Số dư tài khoản không đủ',
    bonusWagering: 'Yêu cầu tiền lương thưởng',
    bonusPrompt: 'Tiền thưởng của tôi | Tiền thưởng hoạt động như thế nào',
    claimBonus: 'Yêu cầu tiền thưởng',
    bonusRequirement: 'Tiền lương',
    howDoesBonusWork: 'Nó hoạt động như thê nào?',
    howDoesBonusWorkItems: [
      'Tiền thưởng là một ưu đãi dành riêng cho người chơi PGEbet có thể được chuyển đổi cho người chơi \' số dư tiền mặt.',
      'Chúng tôi sẽ gửi tiền thưởng vào tài khoản của bạn khi có khuyến mãi.',
      'Số tiền thưởng nhất định của bạn sẽ được chuyển đổi mỗi khi bạn đặt cược (cược). Bạn đặt cược hoặc đặt cược càng nhiều, tiền thưởng của bạn được chuyển đổi càng nhanh.',
      'Bạn có thể từ chuyển từ tiền thưởng thành tiền mặt bất cứ lúc nào.'
    ],
    whatIsBonus: 'Tiền thưởng là gì?',
    whatIsBonusContent: '<div>Yêu cầu đặt cược như nó thường được gọi là số tiền giá trị bạn cần đặt cược để số dư tiền thưởng của bạn chuyển đổi thành tín dụng tiền thật và đủ điều kiện để rút. Ví dụ: Nếu người chơi gửi 1.000 yên với 100% Tiền thưởng và tiền thưởng đó có mức cược 80X, điều đó có nghĩa là số dư tiền thưởng được ghi có vào tài khoản của bạn (1.000 yên) sẽ cần được đặt cược hoặc chơi 80X (80 lần) tiền thưởng của bạn số dư.</div>' +
      '<div style="margin-top: 10px;">₹ 1.000 khoản tiền gửi với Khuyến mãi tiền thưởng 100% khi đặt cọc = ₹ 1,000</div>' +
      '<div style="margin-top: 10px;">Trong ví dụ này, ₹ 1,000 X 80 là yêu cầu đặt cược của bạn = ₹ 80,000</div>' +
      '<div style="margin-top: 10px;">Khi bạn đã chơi gấp 80 lần số dư tiền thưởng của mình (trị giá 80.000 yên cho cược / lần quay), tiền thưởng của bạn sẽ chuyển đổi sang ví chính của bạn và bạn đủ điều kiện để rút tiền của mình.</div>' +
      '<div style="margin-top: 10px;">Để biết thêm thông tin, hãy xem trang điều khoản và điều kiện của chúng tôi.</div>',
    convertBonusSuccess_1: 'Bạn đã chuyển đổi thành công',
    convertBonusSuccess_2: 'tiền thưởng vào số dư tiền mặt của bạn.',
    readyForClaim: 'Sẵn sàng để nhận tiền mặt'
  },
  setting: {
    setting: 'CÀI ĐẶT',
    myInfo: 'THÔNG TIN CỦA TÔI',
    mobile: 'Số điện thoại',
    depositCurrency: 'Tiền gửi ',
    save: 'Lưu',
    saveSuccess: 'Lưu thành công',
    myHistory: 'LỊCH SỬ CỦA TÔI',
    status: 'trạng thái',
    system: 'Hệ thống',
    event: 'Sự kiện',
    personal: 'Riêng tư',
    logout: 'Đăng xuất'
  },
  privacy: [
    {
      class: 't2',
      content: 'Quyền riêng tư của bạn rất quan trọng với chúng tôi. Chính sách của PGEbet là tôn trọng quyền riêng tư của bạn về bất kỳ thông tin nào mà chúng tôi có thể thu thập từ bạn trên trang web của chúng tôi, https://www.pgebet.com và các trang web khác mà chúng tôi sở hữu và vận hành, bao gồm cả Ứng dụng PGEbet.'
    },
    {
      class: 't2',
      content: 'Chúng tôi chỉ yêu cầu thông tin cá nhân khi chúng tôi thực sự cần nó để cung cấp dịch vụ cho bạn. Chúng tôi thu thập nó bằng các phương tiện công bằng và hợp pháp, với sự hiểu biết và sự đồng ý của bạn. Chúng tôi cũng cho bạn biết lý do tại sao chúng tôi thu thập và sử dụng nó như thế nào.'
    },
    {
      class: 't2',
      content: 'Chúng tôi chỉ giữ lại thông tin đã thu thập chừng nào cần thiết để cung cấp cho bạn dịch vụ mà bạn yêu cầu. Dữ liệu nào chúng tôi lưu trữ, chúng tôi sẽ bảo vệ trong các phương tiện thương mại có thể chấp nhận được để ngăn ngừa mất mát và trộm cắp, cũng như truy cập trái phép, tiết lộ, sao chép, sử dụng hoặc sửa đổi.'
    },
    {
      class: 't2',
      content: 'Chúng tôi không chia sẻ bất kỳ thông tin nhận dạng cá nhân nào một cách công khai hoặc với các bên thứ ba.'
    },
    {
      class: 't2',
      content: 'Trang web của chúng tôi có thể liên kết đến các trang bên ngoài không do chúng tôi điều hành. Xin lưu ý rằng chúng tôi không kiểm soát nội dung và thực tiễn của các trang web này, đồng thời không thể chịu trách nhiệm hoặc trách nhiệm pháp lý đối với các chính sách bảo mật tương ứng của chúng.'
    },
    {
      class: 't2',
      content: 'Bạn có thể từ chối yêu cầu của chúng tôi về thông tin cá nhân của bạn, với sự hiểu biết rằng chúng tôi có thể không thể cung cấp cho bạn một số dịch vụ mong muốn của bạn.'
    },
    {
      class: 't2',
      content: 'Việc bạn tiếp tục sử dụng trang web / sòng bạc trực tuyến của chúng tôi sẽ được coi là sự chấp nhận các thông lệ của chúng tôi về quyền riêng tư và thông tin cá nhân. Nếu bạn có bất kỳ câu hỏi nào về cách chúng tôi xử lý dữ liệu người dùng và thông tin cá nhân, vui lòng liên hệ với chúng tôi.'
    },
    {
      class: 't2',
      content: 'Chính sách này có hiệu lực kể từ ngày 12 tháng 7 năm 2020.'
    }
  ],
  responsible: [
    {
      class: 't2',
      content: 'Tại PGEbet, chúng tôi cung cấp các nền tảng và dịch vụ cho phép khách hàng chơi trò chơi và đặt cược. Mục tiêu của chúng tôi là cung cấp một môi trường an toàn, ổn định sẽ mang đến cho bạn trải nghiệm hài lòng và bổ ích. Chúng tôi khuyến khích khách hàng sử dụng dịch vụ của chúng tôi một cách có trách nhiệm và hợp lý.'
    },
    {
      class: 't2',
      content: 'Tất cả các hình thức cá cược đã là một hình thức giải trí phổ biến trong nhiều năm qua tại PGEbet. Chúng tôi khuyến khích bạn vui chơi và chúng tôi chỉ giới thiệu nó cho khách hàng của chúng tôi khi đang vui vẻ.'
    },
    {
      class: 't2',
      content: 'Trong khi hầu hết khách hàng đánh bạc theo cách này, chúng tôi hiểu rằng một số ít khách hàng có thể phát sinh các vấn đề liên quan đến cờ bạc.'
    },
    {
      class: 't2',
      content: 'Tại PGEbet, hạnh phúc của khách hàng là vô cùng quan trọng. Chúng tôi rất coi trọng vai trò cờ bạc của mình và khuyên bạn:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">1.&nbsp;</i>Coi cá cược và trò chơi của bạn như một hình thức giải trí và chỉ sử dụng số tiền bạn đặt để giải trí.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">2.&nbsp;</i>Không đặt cược hoặc đặt cược nhiều hơn giới hạn mà bạn đã đặt.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">3.&nbsp;</i>Đừng đặt cược với số tiền bạn không thể thua.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">4.&nbsp;</i>Đừng đuổi theo sự mất mát của bạn.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">5.&nbsp;</i>Đừng để việc đặt cược và chơi trò chơi của bạn ngăn cản việc sử dụng thời gian cho các hoạt động khác.'
    },
    {
      class: 't2',
      content: 'Nếu bạn có thắc mắc về hành vi cờ bạc hoặc cảm thấy rằng bạn không thể tuân theo các nguyên tắc này, chúng tôi khuyến khích bạn tìm kiếm lời khuyên từ một tổ chức được chứng nhận có thể cung cấp hỗ trợ và lời khuyên.'
    },
    {
      class: 't2',
      content: 'Nếu bạn có thắc mắc về hành vi cờ bạc hoặc cảm thấy rằng bạn không thể tuân theo các nguyên tắc này, chúng tôi khuyến khích bạn tìm kiếm lời khuyên từ một tổ chức được chứng nhận có thể cung cấp hỗ trợ và lời khuyên.'
    },
    {
      class: 't2',
      content: 'Chưa đủ tuổi'
    },
    {
      class: 't2',
      content: 'Nếu bạn muốn đặt cược với chúng tôi tại PGEbet - Bạn phải trên 18 tuổi hoặc độ tuổi hợp pháp tối thiểu để đánh bạc trong khu vực tài phán mà bạn sinh sống. Và được pháp luật cho phép theo luật áp dụng cho bạn.'
    }
  ],
  terms: [
    {
      class: 't2',
      content: 'Các Điều khoản và Điều kiện sau đây chi phối việc sử dụng Sòng bạc Trực tuyến PGEbet. Việc sử dụng PGEbet và hoặc mở tài khoản người dùng là sự thừa nhận rằng người dùng đã đọc, hiểu và đồng ý bị ràng buộc bởi các điều khoản và điều kiện của trang web này. '
    },
    {
      class: 't1',
      content: 'Các thay đổi đối với Điều khoản sử dụng'
    },
    {
      class: 't3',
      content: 'Chúng tôi có quyền thực hiện các thay đổi đối với Điều khoản sử dụng bất kỳ lúc nào. Điều khoản Sử dụng có thể được thay đổi vì một số lý do, bao gồm, nhưng không giới hạn, lý do phục vụ khách hàng, tuân thủ luật hiện hành và hướng dẫn quy định.'
    },
    {
      class: 't3',
      content: 'Chúng tôi khuyên bạn nên truy cập lại và đọc các Điều khoản Sử dụng này thường xuyên, vì chúng điều chỉnh việc sử dụng Trang web của bạn. Chúng tôi sẽ đảm bảo rằng bất kỳ thay đổi nào đối với Điều khoản sử dụng sẽ được thông báo cho bạn bằng một phương thức thích hợp (ví dụ: qua email hoặc thông qua thông báo trên Trang web mà bạn cần xác nhận lại sự chấp nhận của bạn với các điều khoản đó) trước khi có những thay đổi đó có hiệu lực.'
    },
    {
      class: 't3',
      content: 'Bạn có trách nhiệm đảm bảo rằng bạn đồng ý với bất kỳ thay đổi nào được thực hiện đối với Điều khoản sử dụng và việc bạn tiếp tục sử dụng Trang web sẽ được coi là bạn chấp nhận bất kỳ thay đổi nào mà chúng tôi có thể thực hiện.'
    },
    {
      class: 't1',
      content: 'Các bữa tiệc'
    },
    {
      class: 't3',
      content: 'Các Điều khoản Sử dụng sẽ được đồng ý giữa bạn và Công ty. Công ty giao dịch với tên PGEbet Limited (\'PGEbet \'). Trừ khi có quy định khác, \'bạn \', \'của bạn \', \'người dùng \' hoặc \'người chơi \' có nghĩa là bất kỳ người nào sử dụng phần mềm và / hoặc Trang web / Ứng dụng của chúng tôi. Trang web hoặc Trang web cũng có nghĩa là \'Ứng dụng.\''
    },
    {
      class: 't1',
      content: '1. Người dùng \'Tài khoản'
    },
    {
      class: 't3',
      content: '1.1) Người chơi có trách nhiệm giữ bí mật thông tin như đăng nhập {email} và mật khẩu. PGEbet sẽ không chịu trách nhiệm về bất kỳ việc lạm dụng thông tin đăng nhập của người chơi, miễn là PGEbet đã được cung cấp chính xác thông tin tài khoản được yêu cầu. PGEbet có quyền giả định rằng người chơi thực hiện các đơn đặt hàng, thanh toán và hướng dẫn.'
    },
    {
      class: 't3',
      content: '1.2) Mỗi ​​người chơi chỉ được phép mở một Tài khoản Người dùng. Việc sử dụng nhiều hơn một tài khoản cho mỗi Người dùng thực được gọi là “nhiều tài khoản”, điều này bị nghiêm cấm. Nếu chúng tôi phát hiện ra một người chơi có nhiều tài khoản, tất cả các tài khoản liên kết được liên kết với người chơi sẽ bị hủy ngay lập tức cùng với bất kỳ giao dịch nào trên nhiều tài khoản. Trong trường hợp PGEbet có cơ sở hợp lý để nghi ngờ rằng việc đăng ký nhiều tài khoản nói trên đã được thực hiện với mục đích lừa đảo hoặc gian lận, PGEbet có thể chặn việc chơi thường xuyên hoặc giải đấu và / hoặc phân phối giải thưởng.'
    },
    {
      class: 't3',
      content: '1.2.1) Bạn chỉ được phép có một tài khoản người dùng cho mỗi hộ gia đình, mỗi địa chỉ, mỗi máy tính và mỗi địa chỉ IP. Nếu nhiều người trong gia đình bạn có tài khoản, bạn có nguy cơ bất kỳ khoản tiền thắng cược nào bị vô hiệu và bị cấm tham gia sòng bạc trực tuyến. Để biết thêm chi tiết, vui lòng liên hệ với Bộ phận hỗ trợ khách hàng của chúng tôi qua Trò chuyện trực tiếp của chúng tôi.'
    },
    {
      class: 't3',
      content: '1.2.2) PGEbet không cho phép những người dùng tài khoản khác nhau từ cùng một hộ gia đình và / hoặc gia đình chơi trên cùng một cược. Nói cách khác, điều khoản này bao gồm các kết hợp khác nhau của cùng một cược. Nếu người chơi vi phạm điều cấm nói trên, PGEbet có quyền hủy đặt cược đó theo các quy tắc hủy được nêu trong tài liệu này.'
    },
    {
      class: 't1',
      content: '2. Tiền gửi'
    },
    {
      class: 't3',
      content: '2.1) Số tiền ký quỹ phải được sử dụng để đặt cược / tiền cược trong các trò chơi và vì lợi ích của trò chơi công bằng trên trang web của chúng tôi, chúng tôi bị cấm sử dụng bất kỳ kỹ thuật / mô hình cá cược nào đã được công nhận. Bất kỳ hoạt động đáng ngờ nào hoặc đặt cược bất thường vào tài khoản của người chơi có thể khiến PGEbet đóng băng tiền và / hoặc thậm chí đóng tài khoản hoàn toàn.'
    },
    {
      class: 't3',
      content: '2.2) Các khoản tiền đã gửi phải được đặt cược ít nhất một lần trước khi chúng có thể được rút.'
    },
    {
      class: 't3',
      content: '2.3) Trong trường hợp lạm dụng và / hoặc lạm dụng các chương trình khuyến mãi và / hoặc bất kỳ ưu đãi tiền thưởng nào từ PGEbet, sòng bạc trực tuyến có quyền đóng, vô hiệu hóa mọi khoản tiền thắng cược và khóa tài khoản của khách hàng được đề cập cho đến khi có vấn đề giữa PGEbet và khách hàng được giải quyết.'
    },
    {
      class: 't3',
      content: '2.4) Tiền gửi vào tài khoản người chơi được thực hiện bằng cách chuyển tiền vào tài khoản theo phương thức thanh toán trên trang web.'
    },
    {
      class: 't3',
      content: '2.5) Sòng bạc trực tuyến này có quyền thay đổi các hình thức thanh toán mà chúng tôi có thể chấp nhận theo thời gian.'
    },
    {
      class: 't3',
      content: '2.6) Bạn chỉ có thể sử dụng các phương thức thanh toán đã đăng ký dưới tên của chính mình để gửi tiền.'
    },
    {
      class: 't3',
      content: '2.7) Chúng tôi có thể giới hạn số tiền gửi của bạn vào bất kỳ ngày nào.'
    },
    {
      class: 't3',
      content: '2.8) Ngoài ra, chúng tôi có quyền chấp nhận một số phương thức thanh toán chỉ tùy thuộc vào việc thực hiện các điều khoản và điều kiện nhất định.'
    },
    {
      class: 't3',
      content: '2.9) Chúng tôi không đảm bảo rằng tất cả các phương thức thanh toán luôn có sẵn.'
    },
    {
      class: 't3',
      content: '2.10) Chúng tôi không chấp nhận bất kỳ khoản tiền mặt nào được gửi cho chúng tôi.'
    },
    {
      class: 't3',
      content: '2.11) Bằng cách gửi tiền, bạn đồng ý không thực hiện bất kỳ khoản bồi hoàn, đảo ngược hoặc hủy bất kỳ khoản tiền gửi nào vào tài khoản của bạn, đồng thời đồng ý hoàn trả và bồi thường cho chúng tôi các khoản tiền gửi chưa thanh toán.'
    },
    {
      class: 't3',
      content: '2.12) Chúng tôi không chịu trách nhiệm về bất kỳ hoạt động chuyển đổi tiền tệ, phí hoặc lệ phí nào mà công ty phát hành thẻ, ngân hàng hoặc tổ chức tài chính của bạn thu. '
    },
    {
      class: 't3',
      content: '2.13) Xin lưu ý rằng các sản phẩm của chúng tôi được tiêu thụ ngay lập tức khi chơi hoặc cá cược. Điều này có nghĩa là chúng tôi không thể trả lại tiền, hoàn lại tiền hoặc hủy bỏ dịch vụ của bạn khi chơi hoặc cá cược. Nếu bạn chơi trò chơi hoặc dịch vụ bằng tiền thật, tiền sẽ được rút từ tài khoản người chơi của bạn ngay lập tức. '
    },
    {
      class: 't3',
      content: '2.14) Tài khoản người dùng của bạn không nên được sử dụng làm phương tiện / tài khoản ngân hàng và tiền gửi chỉ nên được thực hiện với mục đích sử dụng tiền để đặt cược. Tài khoản của bạn không được bảo hiểm, đảm bảo, tài trợ hoặc bởi bất kỳ hệ thống bảo hiểm ngân hàng nào cũng như không được hưởng lãi suất.'
    },
    {
      class: 't3',
      content: '2.15) Nếu bạn thực hiện nhiều lần gửi và rút tiền mà không đặt cược tương xứng, chúng tôi có quyền chuyển vào tài khoản của bạn mà không cần thông báo trước bất kỳ khoản phí ngân hàng nào mà chúng tôi phải chịu trước khi đóng tài khoản.'
    },
    {
      class: 't3',
      content: '2.16) Bộ mô tả thanh toán: Thẻ tín dụng, thẻ ghi nợ hoặc thẻ thanh toán của bạn sẽ được lập hóa đơn ngay sau khi gửi tiền. Vui lòng liên hệ với bộ phận Hỗ trợ khách hàng nếu có thắc mắc liên quan đến bộ mô tả thanh toán trên bảng sao kê của bạn.'
    },
    {
      class: 't1',
      content: '3.Rút tiền'
    },
    {
      class: 't3',
      content: '3.1) Người dùng có thể yêu cầu thanh toán toàn bộ hoặc một phần từ số dư hiện có trong tài khoản người chơi của mình vào bất kỳ lúc nào với điều kiện là tất cả các khoản thanh toán đã được xác nhận, các yêu cầu đặt cược đã được đáp ứng và tất cả số tiền đã được gửi.'
    },
    {
      class: 't3',
      content: '3.2) Yêu cầu rút tiền được xem xét hàng ngày, từ Thứ Hai đến Chủ Nhật. Chúng tôi mong muốn xem xét tất cả các yêu cầu rút tiền ngay lập tức, kể từ thời điểm người dùng đặt yêu cầu rút tiền trên tài khoản của họ.'
    },
    {
      class: 't3',
      content: '3.3) Người chơi sẽ chỉ có thể rút tiền thắng cược của mình với số tiền lên đến 30.000 USD mỗi tuần hoặc số tiền tương đương bằng INR / CNY / EUR / THB / VND / BTC / USDT. Số tiền còn lại sẽ được đưa trở lại tài khoản của người chơi cho đến khi họ đủ điều kiện rút tiền tiếp. Các chiến thắng jackpot lũy tiến được loại trừ khỏi giới hạn rút tiền hàng tuần. '
    },
    {
      class: 't3',
      content: '3.4) PGEbet có thể giữ lại bất kỳ khoản rút tiền nào trong trường hợp bạn không tuân thủ bất kỳ điều kiện nào mà ban quản lý có thể yêu cầu từ người chơi. '
    },
    {
      class: 't3',
      content: '3.5) Nếu bạn muốn rút một phần hoặc toàn bộ số dư của mình, bạn có thể chọn số tiền bạn muốn được hoàn trả.'
    },
    {
      class: 't3',
      content: '3.6) Tất cả các khoản rút tiền sẽ được trả lại theo cùng một phương thức thanh toán được sử dụng để gửi tiền vào tài khoản. Các phương thức rút tiền sẽ khả dụng sau khi gửi tiền thành công bằng phương thức như vậy. '
    },
    {
      class: 't3',
      content: '3.7) Trường hợp phương thức rút tiền của bạn không còn hợp lệ hoặc khả dụng (ví dụ: nó đã hết hạn) thì việc rút tiền của bạn sẽ không được xử lý và bạn sẽ được hỏi chi tiết về một phương thức thanh toán thay thế. Chúng tôi có thể yêu cầu bạn thêm thông tin hoặc tài liệu trong trường hợp này. '
    },
    {
      class: 't3',
      content: '3.8) Nếu bạn đã yêu cầu rút tiền, bạn sẽ nhận được tiền của mình ngay trong ngày và hầu hết thời gian ngay lập tức, tùy thuộc vào ngân hàng bạn sử dụng. '
    },
    {
      class: 't3',
      content: '3.9) Số tiền rút tối thiểu là 10 USD (70 CNY / 9 EUR hoặc số tiền tương đương). Đối với INR, tối thiểu là 5,00 INR và tối đa 50.000 INR cho mỗi giao dịch. Để thực hiện rút tiền, bạn phải thực hiện hoặc đặt cược tối thiểu một lần trong đời với chúng tôi. '
    },
    {
      class: 't3',
      content: '3.10) Trừ khi có thỏa thuận khác bằng văn bản, số tiền tối đa bạn có thể rút trong bất kỳ tuần nào là 30.000 USD hoặc số tiền tương đương bằng INR / CNY / EUR / THB / VND / BTC / USDT - Hàng tuần. Người chơi VIP có thể đủ điều kiện để được tăng giới hạn rút tiền.'
    },
    {
      class: 't3',
      content: '3.11) Bạn chỉ có thể sử dụng các phương thức thanh toán đã đăng ký dưới tên của chính mình để rút tiền. Bạn có trách nhiệm gửi chi tiết tài khoản ngân hàng chính xác (nếu có) để thanh toán tiền rút. PGEbet không thể hoàn trả các khoản thanh toán do chúng tôi thực hiện cho bất kỳ tài khoản nào khác do chi tiết tài khoản do bạn cung cấp không chính xác.'
    },
    {
      class: 't3',
      content: '3.12) Tiền có thể được khấu trừ từ việc rút tiền tuân theo và theo yêu cầu của bất kỳ quy định hoặc luật hiện hành nào. '
    },
    {
      class: 't3',
      content: '3.13) Là một nhà điều hành trò chơi có trách nhiệm, chiến thắng tối đa trên bất kỳ vòng quay hoặc đặt cược nhất định nào trên PGEbet là 500X số tiền đặt cược. Bất kỳ số tiền thắng nào trong một lần quay duy nhất vượt quá 500X tiền đặt cược của bạn sẽ được coi là Giải Jackpot được đặt trước và sẽ phải chịu mức cược 40X. Đôi khi, ban quản lý PGEbet có thể cung cấp cho người chơi rút tiền đối với Giải đặc biệt được đặt cược, tuy nhiên đây không phải là một thông lệ tiêu chuẩn và sẽ được xử lý theo từng trường hợp. Số dư trong ví chính của người chơi trước khi có Giải Jackpot được đặt trước sẽ vẫn đủ điều kiện rút tiền. '
    },
    {
      class: 't3',
      content: '3.14) Nếu chúng tôi ghi có nhầm vào tài khoản của bạn với số tiền thắng không thuộc về bạn, cho dù do lỗi kỹ thuật, lỗi trong bảng thanh toán, lỗi của con người hay cách khác, số tiền sẽ vẫn là tài sản của chúng tôi và số tiền đó sẽ bị trừ từ tài khoản của bạn. Nếu bạn đã sử dụng bất kỳ số tiền nào như vậy để đặt cược, chúng tôi có thể hủy bỏ các cược này và vô hiệu hóa mọi khoản tiền thắng cược. Nếu bạn đã rút các khoản tiền không thuộc về bạn trước khi chúng tôi nhận ra lỗi, số tiền thanh toán nhầm sẽ (không ảnh hưởng đến các biện pháp khắc phục và hành động khác có thể có theo luật định) tạo thành khoản nợ mà bạn phải trả cho chúng tôi và chúng tôi có thể thực hiện các bước để thu hồi số tiền đó. Trong trường hợp ghi có không chính xác, bạn có nghĩa vụ thông báo cho chúng tôi ngay lập tức qua email.'
    },
    {
      class: 't3',
      content: '3.15) Tất cả các giao dịch sẽ được kiểm tra để ngăn chặn rửa tiền. Nếu bạn biết bất kỳ hoạt động đáng ngờ nào liên quan đến bất kỳ trò chơi nào hoặc bất kỳ thứ gì liên quan đến Trang web, bạn phải báo cáo điều này ngay lập tức cho chúng tôi. Chúng tôi có thể tạm ngưng, phong tỏa hoặc đóng tài khoản và giữ lại tiền nếu được yêu cầu theo luật hiện hành. Hơn nữa, đối với các mục đích AML / KYC, khi yêu cầu rút tiền, bạn sẽ được yêu cầu cung cấp các giấy tờ tùy thân được yêu cầu, nếu bạn chưa làm như vậy.'
    },
    {
      class: 't3',
      content: '3.16) Thẩm định nâng cao có thể được thực hiện liên quan đến việc rút tiền không được sử dụng để đặt cược.'
    },
    {
      class: 't3',
      content: '3.17) Hoàn trả được cung cấp cho các lỗi rõ ràng, bao gồm các lỗi rõ ràng hiển thị các khoản tiền gửi và rút / thanh toán không chính xác. Vui lòng liên hệ với bộ phận Hỗ trợ Trực tiếp của chúng tôi nếu yêu cầu hoàn lại tiền.'
    },
    {
      class: 't3',
      content: '3.18) Bạn có thể rút tiền bất kỳ lúc nào và việc rút tiền được xử lý ngay trong ngày nếu không phải ngay lập tức. Tuy nhiên, có thể mất đến 48 giờ để tiền đến một số ngân hàng.'
    },
    {
      class: 't1',
      content: '4. Tiếp thị & Khuyến mại'
    },
    {
      class: 't3',
      content: '4.1) Tín dụng tiền thưởng có thể được chuyển vào tài khoản của người chơi như một phần của chiến dịch khuyến mại. Các khoản tín dụng này không thể rút hoặc trả hết, nhưng chúng phải được sử dụng để đặt cược theo cách được nêu trong các quy tắc tương ứng của các chiến dịch khuyến mãi tiền thưởng tiếp thị khác nhau.'
    },
    {
      class: 't3',
      content: '4.2) PGEbet có quyền giữ lại hoặc đảo ngược bất kỳ khoản thanh toán hoặc số tiền thắng cược hoặc sửa đổi bất kỳ chính sách nào của trang web trong trường hợp có nghi ngờ hợp lý rằng người chơi đang lạm dụng hoặc cố gắng lạm dụng bất kỳ khoản tiền thưởng, khuyến mại tiếp thị hoặc cụ thể nào chính sách và điều khoản được xác định liên quan đến trò chơi hiện có hoặc trò chơi mới.'
    },
    {
      class: 't3',
      content: '4.3) PGEbet giữ quyền xác định tuyệt đối rằng một hành vi lạm dụng như vậy đã diễn ra; Ngoài ra, nếu bản thân hoạt động trực tuyến của bạn trong PGEbet không phải là lạm dụng, nhưng các hoạt động của bạn trong các sòng bạc trực tuyến khác ngoài sòng bạc trực tuyến của chúng tôi, xét về tổng thể, cấu thành hành vi lạm dụng tiền thưởng, khuyến mại, chính sách hoặc điều khoản của chúng tôi.'
    },
    {
      class: 't3',
      content: '4.4) Yêu cầu trả lương đối với tiền thưởng là bắt buộc trước khi cho phép bất kỳ khoản tiền mặt nào. Xin lưu ý: Yêu cầu đặt lương đối với tiền thưởng sẽ khác nhau theo từng chương trình khuyến mãi. '
    },
    {
      class: 't3',
      content: '4.5) Khi các yêu cầu chơi qua bắt buộc được đáp ứng, tiền có thể được chuyển từ tài khoản tiền thưởng của người chơi sang tài khoản tiền mặt của họ. '
    },
    {
      class: 't3',
      content: '4.6) Khi yêu cầu rút tiền đã được thực hiện, bạn chỉ có thể rút tiền từ tài khoản tiền mặt của mình. Khi các yêu cầu đặt cược đã được đáp ứng cho tài khoản tiền thưởng của bạn, số tiền này có thể được chuyển đổi thành tài khoản tiền mặt của bạn. '
    },
    {
      class: 't3',
      content: '4.7) Xin lưu ý: Chỉ những người chơi đã đăng ký mới đủ điều kiện nhận tiền thưởng miễn phí, tiền thưởng đăng ký hoặc trở thành người chơi VIP. Và hoàn toàn không có người chơi nào từ Hoa Kỳ được phép hoặc đủ điều kiện nhận khuyến mãi tiền thưởng.'
    },
    {
      class: 't3',
      content: '4.8) Người chơi chỉ có thể đổi 1 (một) tiền thưởng tại một thời điểm.'
    },
    {
      class: 't3',
      content: '4.9) Khi tiền thưởng đã được đổi và bạn đã nạp tiền, tiền thưởng của bạn sẽ tự động được thêm vào tài khoản của bạn. Tiền thưởng sẽ bị xóa khỏi tài khoản của người chơi sau khi yêu cầu rút tiền được thực hiện. '
    },
    {
      class: 't3',
      content: '4.10) Hãy chắc chắn rằng bạn đã đọc và hiểu từng điều khoản tiền thưởng riêng lẻ trước khi sử dụng bất kỳ khoản tiền thưởng nào để tránh hiểu nhầm. '
    },
    {
      class: 't3',
      content: '4.11) Phần thưởng sẽ hết hạn trong vòng 7 ngày sau khi có trong tài khoản của bạn. Nếu bạn không đáp ứng các điều kiện của tiền thưởng trong khung thời gian này, mọi số tiền thưởng và tiền thắng cược liên quan đến tiền thưởng này sẽ bị xóa khỏi tài khoản của bạn. '
    },
    {
      class: 't3',
      content: '4.12) Đôi khi, PGEbet có thể cung cấp các khoản tiền thưởng lớn được phân bổ cho các chiến dịch khuyến mãi không có sẵn trên trang web mà chỉ thông qua chiến dịch. '
    },
    {
      class: 't3',
      content: '4.13) Việc sử dụng tiền thưởng khi gửi tiền sẽ được coi là thể hiện sự chấp nhận tất cả các điều khoản và điều kiện liên quan đến việc sử dụng tiền thưởng khuyến mại đã nêu ở trên. Người chơi không bắt buộc phải sử dụng tiền thưởng khi gửi tiền và không nên làm như vậy khi chưa hiểu rõ về các điều khoản và điều kiện này. '
    },
    {
      class: 't3',
      content: '4.14) Bất kỳ khoản tiền miễn phí nào được đưa ra mà không yêu cầu đặt cọc, ví dụ: tiền thưởng không cần gửi tiền, phần thưởng dành cho khách hàng thân thiết, điểm tổng hợp, phần thưởng VIP, phần thưởng cạnh tranh / giải đấu, phần thưởng bồi thường, phần thưởng cho sự bất tiện, phần thưởng sinh nhật, v.v. (trừ khi có quy định khác) sẽ có số tiền mặt tối đa là 10.000 đô la Mỹ hoặc tương đương hoặc gấp 10 lần số tiền thưởng. Yêu cầu đặt cược tiền thưởng ban đầu tối thiểu và yêu cầu tiền mặt tối thiểu được áp dụng. '
    },
    {
      class: 't3',
      content: '4.15) Vì lý do bảo mật, mọi khoản tiền thắng cược từ tiền thưởng miễn phí hoặc tiền thắng cược từ một giải đấu miễn phí, sẽ chỉ được quy ra tiền mặt sau khi gửi tối thiểu 10 đô la Mỹ (hoặc số tiền tương đương) vào tài khoản người chơi.'
    },
    {
      class: 't3',
      content: '4.16) Lưu ý: Tất cả tiền thưởng ngay lập tức không bao gồm các trò chơi lũy tiến.'
    },
    {
      class: 't3',
      content: '4.17) Nếu người chơi yêu cầu tiền thưởng từ 100% trở lên số tiền gửi của họ, số tiền rút tối đa sẽ gấp 5 lần số tiền gửi sau khi hoàn thành tất cả các yêu cầu đặt cược liên quan đến tiền thưởng được ghi có. Phần còn lại của yêu cầu rút tiền sẽ bị vô hiệu. Ban quản lý Sòng bạc có quyền thực hiện điều khoản này khi thấy thích hợp. '
    },
    {
      class: 't3',
      content: '4.18) Người chơi phải mở một tài khoản sòng bạc thực mới tại PGEbet, yêu cầu tiền thưởng (sử dụng mã tiền thưởng được chỉ định) trong thủ quỹ và trong trường hợp các chương trình khuyến mãi của bên thứ ba đã được giới thiệu bởi các đối tác tiếp thị cụ thể của chúng tôi đã được ủy quyền và trước đã chấp thuận để cung cấp phần thưởng độc quyền này. '
    },
    {
      class: 't3',
      content: '4.19) Mọi khoản tiền khuyến mãi miễn phí tối đa là 1.000 USD (hoặc số tiền tương đương) miễn phí, không cần đặt cọc. Số tiền này không thể được tăng lên hoặc phân bổ lại trong thời gian khuyến mãi. Số tiền tối đa mà người chơi có thể rút từ tiền thưởng này là 2.000 USD (hoặc số tiền tương đương). Mọi khoản tiền bổ sung sẽ tự động bị xóa sau khi các yêu cầu đặt cược của phần thưởng đã được hoàn thành. '
    },
    {
      class: 't3',
      content: '4.20) Bạn sẽ được yêu cầu hoàn thành số tiền yêu cầu của chương trình khuyến mãi tiền thưởng miễn phí trước khi có thể thực hiện rút tiền.'
    },
    {
      class: 't3',
      content: '4.21) Phần thưởng này chỉ có thể được nhận một lần bởi người chơi, cá nhân hoặc hộ gia đình. Bất kỳ người chơi nào bị phát hiện mở nhiều tài khoản để yêu cầu phần thưởng này sẽ bị đóng băng tài khoản của họ và mọi khoản tiền bị tịch thu.'
    },
    {
      class: 't1',
      content: '5. Trách nhiệm của bạn'
    },
    {
      class: 't3',
      content: '5.1) Người chơi ít nhất 18 tuổi hoặc đã đủ tuổi trưởng thành hợp pháp trong khu vực tài phán của mình, tùy theo mức nào lớn hơn. Hoạt động cờ bạc Sòng bạc Trực tiếp và Ảo của PGEbet Casino chỉ hướng tới những người chơi theo luật của khu vực pháp lý tại nhà của họ không bị cấm đánh bạc trên internet thông qua ứng dụng của phần mềm. Một số khu vực pháp lý vẫn chưa giải quyết tính hợp pháp của việc sử dụng phần mềm để đánh bạc, trong khi một số khu vực pháp lý đặc biệt coi cờ bạc trên internet là bất hợp pháp. '
    },
    {
      class: 't3',
      content: '5.2) PGEbet không thể xác định tình trạng của luật pháp ở mọi khu vực tài phán trên toàn thế giới một cách liên tục. Do đó, người chơi hoàn toàn chịu trách nhiệm về việc xác định luật áp dụng trong phạm vi quyền hạn của mình. Người chơi chịu trách nhiệm về bất kỳ hậu quả nào có thể xảy ra do họ không xác định được tính hợp pháp của trò chơi trên internet trong phạm vi quyền hạn của mình. Người chơi hiểu rằng người chơi có thể chơi trò chơi miễn phí hoặc miễn phí. Người chơi hiểu rằng các trò chơi chỉ mang giá trị giải trí và do người chơi quyết định. Việc sử dụng PGEbet Casino cho mục đích thương mại bị nghiêm cấm. Người chơi sẽ chỉ chơi cho mục đích riêng tư và không chuyên nghiệp. Trước khi đặt cược, người chơi có trách nhiệm xác minh luật cờ bạc điều chỉnh nơi sử dụng PGEbet Casino. '
    },
    {
      class: 't3',
      content: '5.3) Người chơi sẽ coi công ty, nhân viên, cán bộ, giám đốc, người được cấp phép, nhà phân phối, người bán buôn, chi nhánh, công ty con, quảng cáo, khuyến mại hoặc các cơ quan khác, đối tác truyền thông, đại lý và nhà bán lẻ là vô hại và vô tội vạ, và sẽ hoàn toàn bồi thường như nhau từ bất kỳ và tất cả các chi phí, chi phí, trách nhiệm pháp lý và thiệt hại có thể phát sinh do người chơi: '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">a.&nbsp;</i>vào, sử dụng hoặc tái sử dụng trang web, '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">b.&nbsp;</i>sử dụng bất kỳ tài liệu nào tại trang web,'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">c.&nbsp;</i>vào, sử dụng hoặc tái sử dụng máy chủ sòng bạc, '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">d.&nbsp;</i>tham gia vào các trò chơi, hoặc'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">e.&nbsp;</i>việc chấp nhận bất kỳ giải thưởng nào.'
    },
    {
      class: 't3',
      content: '5.4) Người chơi phải xem xét định kỳ với tỷ lệ không ít hơn một lần hàng tháng các Điều khoản và Điều kiện được đăng trên Trang web này. '
    },
    {
      class: 't3',
      content: '5.5) Người chơi không được tham gia vào các trò chơi, mở, sử dụng hoặc tái sử dụng tài khoản, vào Trang web hoặc sòng bạc, cũng như không nhận bất kỳ giải thưởng nào nếu người chơi không hiểu đầy đủ, đồng ý, trở thành một bên và sẽ tuân theo , không có ngoại lệ, tất cả các quy tắc, quy định, điều khoản và điều kiện có trong tài liệu này và các quy tắc, quy định, điều khoản và điều kiện đó có thể thay đổi định kỳ. '
    },
    {
      class: 't3',
      content: '5.6) Người chơi có nghĩa vụ giữ bí mật và bí mật tên người dùng và mật khẩu riêng tư của mình. Mọi việc sử dụng ứng dụng phần mềm thông qua tên người dùng của người chơi là trách nhiệm duy nhất của người chơi. '
    },
    {
      class: 't3',
      content: '5.7) Người chơi sẽ không cho phép bất kỳ bên thứ ba hoặc người nào, bao gồm và không giới hạn đối với bất kỳ trẻ vị thành niên nào, sử dụng tài khoản của mình để đặt cược hoặc tham gia vào các trò chơi theo bất kỳ cách nào. Người chơi hoàn toàn chịu trách nhiệm về mọi khoản thuế và phí áp dụng cho tiền thắng cược do sử dụng phần mềm. '
    },
    {
      class: 't3',
      content: '5.8) Nếu tiền thắng cược bị đánh thuế trong phạm vi quyền hạn của người chơi, thì người chơi được yêu cầu theo dõi và báo cáo tiền thắng cược cho các cơ quan có thẩm quyền thích hợp. Danh tính cá nhân và thông tin chi tiết của tất cả các thành viên sẽ được giữ bí mật. PGEbet Casino sẽ không báo cáo thông tin cá cược thay mặt cho bất kỳ người dùng nào. '
    },
    {
      class: 't3',
      content: '5.9) PGEbet có quyền hủy bỏ tư cách thành viên của bạn bất kỳ lúc nào mà không cần thông báo. Mọi số dư trong tài khoản của bạn sẽ được ghi có ngay lập tức vào thẻ tín dụng hoặc thẻ thanh toán của bạn. Ngoài ra, PGEbet có toàn quyền quyết định vô hiệu mọi khoản tiền thắng cược và giữ lại mọi số dư trong tài khoản sòng bạc PGEbet của bạn trong bất kỳ trường hợp nào sau đây: '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">a.&nbsp;</i>Nếu tên trên tài khoản PGEbet Casino không khớp với tên trên (các) thẻ thanh toán / tín dụng được sử dụng để gửi tiền vào tài khoản.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">b.&nbsp;</i>Nếu bạn cung cấp thông tin sai và gây hiểu lầm được sử dụng để mở tài khoản PGEbet. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">c.&nbsp;</i>Nếu bạn không đủ tuổi hợp pháp tại khu vực tài phán nơi bạn cư trú. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">d.&nbsp;</i>Nếu bạn cư trú tại một khu vực tài phán, nơi luật pháp nghiêm cấm việc sử dụng và tham gia các trò chơi đó.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">e.&nbsp;</i>Nếu bạn đã (có chủ ý hoặc không) cho phép bên thứ ba chơi trên tài khoản PGEbet của bạn.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">f.&nbsp;</i>Nếu bạn đã đảo ngược hoặc được trả lại tiền đối với các thanh toán trênt tài khoản PGEbet Casino.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">g.&nbsp;</i>Bạn chỉ được phép có một tài khoản ở nhà, máy tính hoặc cơ quan. Các khoản thắng cược sẽ được trả cho những người chơi có một tài khoản. Nếu bạn có nhiều hơn một tài khoản, tiền thắng cược sẽ không được tính.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">h.&nbsp;</i>Nếu bị phát hiện gian dối, hoặc PGEbet quyết định rằng bạn sử dụng hệ thống, chiến thuật hoặc máy móc, như máy tính, phần mềm bên ngoài, sử dụng hệ thống cá cược Martingale hoặc bất kỳ hệ thống khác sử dụng để  làm hỏng hệ thống ngẫu nhiên của chúng tôi.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">i.&nbsp;</i>Tên trên tài khoản sòng bài không khớp với tên trên tài khoản người nhận hoặc công cụ tài chính dùng để nạp hoặc rút tiền.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">j.&nbsp;</i>Nếu thông tin tài chính, thông tin cá nhân hoặc thủ đoạn chơi game của bạn tương tự với những kẻ lừa đảo đảo hoặc bị coi là rủi ro cao hoặc lạm dụng bởi đội ngũ an ninh của chúng tôi.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">k.&nbsp;</i>Nếu bạn không đăng nhập vào tài khoản sòng bài trong vòng 90 ngày, số dư tài khoản sẽ được chuyển về Công ty (PGEbet).'
    },
    {
      class: 't1',
      content: '6. Hỗ trợ trực tiếp'
    },
    {
      class: 't3',
      content: 'Chúng tôi cung cấp cho người dùng công cụ nhắn tin trực tiếp cho phép bạn giao tiếp với Nhóm hỗ trợ Chăm sóc khách hàng của chúng tôi. Chúng tôi có thể sẽ xem xét và lưu lại toàn bộ nội dung trao đổi trong công cụ nhắn tin. Chúng tôi có quyền cuối cùng để loại bỏ hoặc sửa đổi công cụ nhắn tin tuỳ ý.'
    },
    {
      class: 't1',
      content: '7. Hoàn tiền'
    },
    {
      class: 't3',
      content: 'Không yêu cầu đăng ký để tham gia nhận hoàn tiền. Các giải thưởng hoàn tiền đều thường xuyên có sẵn cho người chơi. Để đủ điều kiện nhận giải thưởng hoàn tiền, bạn cần đáp ứng một số quy tắc sau.'
    },
    {
      class: 't3',
      content: '7.1) Nhận 10% hoàn tiền trên tổng số tiền thua cược của tuần (nếu có).'
    },
    {
      class: 't3',
      content: '7.2) Số dư có sẵn của bạn phải dưới $100 USD (hoặc tương đương) để đủ điều kiện tham gia.'
    },
    {
      class: 't3',
      content: '7.3) Bạn không có khoản rút tiền đang chờ trên hệ thống.'
    },
    {
      class: 't3',
      content: '7.4) Ưu đãi này chỉ dành cho người chơi đã nộp từ 200 USD (hoặc tương đương) trở lên trong tuần trước.'
    },
    {
      class: 't3',
      content: 'Lưu ý: Hoàn tiền (nếu có) được tự động phân bổ về tài khoản vào 10h00 sáng thứ hai hàng tuần (giờ IST)'
    },
    {
      class: 't1',
      content: '8. Thưởng và Lượt quay miễn phí'
    },
    {
      class: 't3',
      content: '8.1) Lượt quay miễn phí không phải là tiền thật. Lượt quay miễn phí là một phần của thưởng và phụ thuộc vào đặt cược thưởng và các điều khoản khác về thưởng.'
    },
    {
      class: 't3',
      content: '8.2) Số tiền thắng từ Lượt quay miễn phí sẽ được gửi tới tài khoản thưởng của bạn, và tuân theo các điều khoản và điều kiện tiêu chuẩn, điều khoản thưởng và yêu cầu đặt cược của chúng tôi. Tuy nhiên, tiền thắng cược sau hoàn thành yêu cầu đặt cược là tiền thật và có thể rút về.'
    },
    {
      class: 't3',
      content: '8.3) Yêu cầu đặt cược đối với tiền thưởng khác nhau với mỗi chương trình.'
    },
    {
      class: 't3',
      content: '8.4) Khi đặt cược, tiền trong tài khoản chính sẽ được dùng trước tiền thưởng.'
    },
    {
      class: 't3',
      content: '8.5) Tiền thưởng hoặc lượt quay miễn phí chỉ được dành cho một tài khoản/cá nhân/gia đình/địa chỉ IP trong thời gian diễn ra chương trình khuyến mại trừ khi có quy định khác.'
    },
    {
      class: 't3',
      content: '8.6) Để yêu cầu rút tiền, bạn phải đặt cược tối thiểu 40 lần số tiền thưởng, trừ khi có quy định khác trong chương trình khuyến mãi.'
    },
    {
      class: 't3',
      content: '8.7) Tiền thưởng có thời hạn hiệu lực trong vòng 7 ngày, trừ khi có quy định khác. Mỗi khách hàng phải đáp ứng yêu cầu trò chơi trước ngày tiền thưởng hết hạn, hoặc không, tiền thưởng, hoặc tiền thưởng và số tiền thắng cược từ tiền thưởng đó sẽ bị xoá khỏi tài khoản người chơi sau khi tiền thưởng hết hạn.'
    },
    {
      class: 't3',
      content: '8.8) Các khoản rút tiền hoàn lại không được coi là tiền gửi và sẽ không được kết hợp với tiền thưởng.'
    },
    {
      class: 't3',
      content: '8.9) Đặt cược cho tất cả các trò chơi tại sòng bạc của chúng tôi góp phần vào yêu cầu đặt cược nhưng một số trò chơi nhất định đóng góp số tiền lớn hơn các trò chơi khác.'
    },
    {
      class: 't3',
      content: '8.10) Sau khi nhận thưởng từ tiền nạp, số dư tiền thưởng của người dùng sẽ hiển thị trên ví thưởng. Sau khi người chơi hoàn thành yêu cầu cược, hoặc "không tham gia" đặt cược, thì số dư tiền thưởng sẽ được hiển thị trên ví chính của người chơi.'
    },
    {
      class: 't3',
      content: '8.11) Tất cả người chơi có tiền thưởng yêu cầu phải đặt cược tiền, sẽ có lựa chọn không tham gia vào trò chơi cá cược bất cứ lúc nào. "Không tham gia" nghĩa là người chơi không muốn đặt cược và số tiền được chuyển vào ví chính của người dùng sẽ là % của số dư tiền thưởng đã hoàn thành đặt cược tại thời điểm chọn không tham gia. Ví dụ: - Nếu người dùng gửi $ 1000 với 100% tiền thưởng tiền gửi, ví Tiền thưởng của họ sẽ hiển thị số dư $ 2000 với yêu cầu đặt cược số tiền "40X". Nếu người dùng sau đó hoàn thành 25% yêu cầu đặt cược của họ và số dư tiền thưởng của họ tại thời điểm đó là $12.000 - thì người dùng có tùy chọn “chọn không tham gia”, theo đó 25% (số tiền đặt cược đã hoàn thành) của Số dư tiền thưởng $12.000 (là $ 3000), sẽ tự động được chuyển vào số dư ví chính của người dùng và đủ điều kiện để rút. '
    },
    {
      class: 't3',
      content: '8.12) Không thể yêu cầu rút tiền mặt số tiền thưởng. Người chơi không thể rút bất kỳ khoản tiền thắng cược nào từ số dư tiền thưởng cho đến khi đáp ứng tất cả các yêu cầu đối với phần thưởng được nêu tên.'
    },
    {
      class: 't3',
      content: '8.13) Khi các yêu cầu đặt cược được đáp ứng, tiền sẽ tự động được chuyển từ số dư tiền thưởng sang số dư tiền mặt. '
    },
    {
      class: 't3',
      content: '8.14) Nếu chúng tôi tin rằng một khách hàng không được bao gồm trong một chương trình khuyến mãi tiền thưởng cụ thể, tiền thưởng sẽ không được trao và sẽ không có khoản thanh toán nào tiếp theo được đưa ra. Chúng tôi có quyền từ chối cho phép tham gia chương trình khuyến mãi mà không cần giải thích thêm.'
    },
    {
      class: 't3',
      content: '8.15) PGEbet có thể, theo quyết định riêng của mình, thay đổi các điều khoản và điều kiện hoặc giới hạn tư cách người chơi tham gia vào chương trình khuyến mãi này, vì bất kỳ lý do gì mà không cần thông báo trước cho người dùng cuối.'
    },
    {
      class: 't3',
      content: '8.16) Tiền thưởng do Sòng bạc của chúng tôi cung cấp chỉ dành cho những người chơi giải trí chân chính. Việc lạm dụng bất kỳ ưu đãi tiền thưởng nào sẽ không được dung thứ. Chúng tôi có quyền điều tra, hủy bỏ, đình chỉ hoặc khóa bất kỳ tài khoản nào nếu nghi ngờ lạm dụng tiền thưởng. Theo quyết định của chúng tôi, tất cả tiền thưởng và hoạt động chơi trò chơi tiếp theo có thể bị thu hồi và vô hiệu hóa, đồng thời tiền gửi sẽ được trả lại.'
    },
    {
      class: 't3',
      content: '8.17) nếu PGEcet nghi ngờ rằng một người chơi đã lạm dụng tiền thưởng, tự mình hoặc liên kết với các đối tác, PGEcet có quyền tước bỏ tiền thưởng và vô hiệu mọi khoản tiền thắng cược.'
    },
    {
      class: 't1',
      content: '9. Tiền bồi thường'
    },
    {
      class: 't3',
      content: 'Ngoài ra, bạn đồng ý hoàn toàn bồi thường, bảo vệ và giữ chúng tôi và các cán bộ, giám đốc, nhân viên, đại lý, nhà thầu và nhà cung cấp của chúng tôi vô hại, khỏi và chống lại tất cả các khiếu nại, trách nhiệm pháp lý, thiệt hại, tổn thất, chi phí bao gồm cả phí pháp lý, phát sinh từ việc bạn vi phạm Thỏa thuận này và bất kỳ trách nhiệm pháp lý nào khác phát sinh từ việc bạn sử dụng Sòng bạc Trực tuyến PGEbet hoặc phần mềm liên quan.'
    },
    {
      class: 't1',
      content: '10. Bảo mật'
    },
    {
      class: 't3',
      content: 'Bạn sẽ không đột nhập, truy cập, cố gắng đột nhập hoặc bằng cách khác vượt qua bảo mật của chúng tôi. Nếu chúng tôi nghi ngờ rằng bạn đã cố gắng hoặc có thể đang cố gắng đột nhập, truy cập hoặc bằng cách khác vượt qua bảo mật của chúng tôi hoặc phần mềm, chúng tôi sẽ có quyền chấm dứt ngay lập tức quyền truy cập của bạn vào Sòng bạc PGEbet và/hoặc của khoá tài khoản của bạn và chúng tôi có quyền thông báo cho các cơ quan có thẩm quyền.'
    },
    {
      class: 't3',
      content: '10.1) Bạn thừa nhận rằng trình tạo số ngẫu nhiên của chúng tôi sẽ xác định kết quả của các trò chơi được chơi trên Sòng bạc PGEbet và bạn chấp nhận kết quả của tất cả các trò chơi đó. Bạn cũng đồng ý rằng trong trường hợp hi hữu xảy ra bất đồng giữa kết quả xuất hiện trên phần mềm và máy chủ trò chơi, kết quả xuất hiện trên máy chủ trò chơi sẽ được ưu tiên. Bạn thừa nhận và đồng ý rằng hồ sơ của chúng tôi sẽ là cơ quan cuối cùng trong việc xác định các điều khoản và trường hợp bạn tham gia vào hoạt động chơi Sòng bạc Trực tuyến.'
    },
    {
      class: 't3',
      content: '10.2) Bạn sẽ không thực hiện bất kỳ hành vi nào hoặc có bất kỳ hành vi nào gây tổn hại đến danh tiếng của chúng tôi hoặc bất kỳ nhà cung cấp dịch vụ liên quan nào khác. '
    },
    {
      class: 't1',
      content: '11. Trách nhiệm pháp lý'
    },
    {
      class: 't3',
      content: 'Sòng bạc PGEbet bị giới hạn đối với những cá nhân trên Đa số hợp pháp là cư dân của các khu vực pháp lý (“Người chơi / Người chơi”) nơi việc sử dụng Sòng bạc PGEbet và các trò chơi của nó không bị pháp luật cấm. Tất cả các trò chơi của PGEbet Casino đều vô hiệu và không được phép truy cập ở những nơi bị pháp luật cấm. Nghiêm cấm trẻ vị thành niên chơi.'
    },
    {
      class: 't1',
      content: '12. Sử dụng phần mềm'
    },
    {
      class: 't3',
      content: 'PGEbet Casino theo đây cấp cho người chơi giấy phép cá nhân, không độc quyền, không thể chuyển nhượng để sử dụng phần mềm chơi trong Casino Trực tuyến.'
    },
    {
      class: 't3',
      content: 'PGEbet Casino sử dụng hệ thống mã hóa tiên tiến để bảo vệ thông tin tên người dùng và mật khẩu cũng như bất kỳ thông tin tế nhị nào khác được chuyển đến và đi từ ứng dụng khách và máy chủ PGEbet Casino, do đó bảo vệ người chơi và Sòng bạc trước việc bị thao túng của bên thứ ba.'
    },
    {
      class: 't1',
      content: '13. Trọng tài'
    },
    {
      class: 't3',
      content: '13.1) PGEbet sẽ đóng vai trò là trọng tài cuối cùng hoặc bất kỳ tranh chấp nào liên quan đến PGEbet Casino và bất kỳ bên nào khác. PGEbet có quyền thuê một trọng tài viên do mình lựa chọn để làm đại lý phân xử thay cho PGEbet trong trường hợp có tranh chấp.'
    },
    {
      class: 't3',
      content: '13.2) Tất cả các tranh chấp phải được chuyển đến PGEbet Casino qua email trong vòng một (1) giờ kể từ khi xảy ra tranh chấp. PGEbet Casino sẽ trả lời tất cả khách hàng trong vòng 2 ngày làm việc. Trong trường hợp có tranh chấp, mọi quyết định của sòng bạc sẽ là quyết định cuối cùng.'
    },
    {
      class: 't3',
      content: '13.3) Nếu bất kỳ trò chơi Slot game nào bị gián đoạn và/hoặc ngắt kết nối bất kỳ lúc nào, thì tình huống tại thời điểm bị gián đoạn và kết quả từ trò chơi trước đó sẽ được hiển thị khi người chơi bắt đầu lại trò chơi. Nếu người chơi bị ngắt kết nối với máy chủ trò chơi Live Table của PGEbet giữa trận đấu, tiền đặt cược sẽ bị hủy và lần đặt cược cuối cùng của người chơi sẽ không được hoàn trả, do tính chất trực tiếp của các trò chơi trực tiếp Live Table của chúng tôi. Tuy nhiên, điều này sẽ không bao giờ xảy ra.'
    },
    {
      class: 't3',
      content: '13.4) PGEbet Casino luôn nỗ lực hết sức để đảm bảo khách hàng được bảo vệ đầy đủ. Tuy nhiên, một số sự kiện không lường trước được nằm ngoài tầm kiểm soát của PGEbet. Trong trường hợp mất kết nối vì bất kỳ lý do gì giữa người chơi và Sòng bạc, PGEbet sẽ không chịu trách nhiệm về bất kỳ tổn thất nào có thể xảy ra từ đó. Số dư trong tài khoản của người chơi sẽ luôn được ghi lại trên máy chủ PGEbet Casino.'
    },
    {
      class: 't1',
      content: '14. Thanh toán'
    },
    {
      class: 't3',
      content: '14.1) Trước khi bất kỳ khoản rút tiền nào được xử lý, trò chơi của bạn sẽ được xem xét có bất kỳ kiểu chơi bất thường nào không. Vì lợi ích của trò chơi công bằng, các khoản cá cược ngang bằng, không hoặc có tỷ lệ ký quỹ thấp hoặc cá cược bảo hiểm, tất cả sẽ được coi là chơi trò chơi bất thường cho các mục đích yêu cầu phát thưởng. Các ví dụ khác về chơi trò chơi bất thường bao gồm nhưng không giới hạn, đặt cược đơn tương đương hoặc vượt quá 30% giá trị tiền thưởng được ghi có vào tài khoản của họ khi các yêu cầu đặt cược cho phần thưởng đó được đáp ứng. Nếu Sòng bạc cho rằng việc chơi trò chơi bất thường đã xảy ra, PGEbet có quyền giữ lại bất kỳ khoản rút tiền nào và/hoặc tịch thu tất cả tiền thắng cược.'
    },
    {
      class: 't3',
      content: '14.2) Ngoài những điều trên, khi xử lý lệnh rút tiền, nếu số tiền gửi tích lũy của người chơi không vượt quá $5.000 (hoặc số tiền tương đương), người chơi chỉ được hưởng số tiền tối đa là 10 x số tiền này trong một yêu cầu rút tiền (dựa trên tiền thắng cược). Ví dụ: tiền gửi tích lũy $200, tiền thắng $2500, yêu cầu rút tiền $2500, thanh toán hiệu lực chỉ $2000, $500 được giảm từ số dư của người chơi. Cũng xin lưu ý, chúng tôi có quyền thanh toán tiền rút của bạn bằng phương thức thanh toán thuận tiện nhất cho Sòng bạc.'
    },
    {
      class: 't3',
      content: '14.3) PGEbet Casino sẽ sử dụng những công cụ hợp lý của mình để trả tiền của người chơi bằng phương pháp ưa thích của họ. Tuy nhiên, khi cần thiết để tuân thủ luật pháp, quy định địa phương và để đảm bảo an ninh cho cả hai bên, PGEbet Casino có quyền trả tiền thắng cược của người chơi bằng cách sử dụng phương thức thanh toán phù hợp nhất do PGEbet quyết định.'
    },
    {
      class: 't3',
      content: '14.4) Bất kỳ khoản tiền gửi nào được thực hiện vào tài khoản Sòng bạc của bạn đều là dấu hiệu cho Sòng bạc về ý định đặt cược của bạn tại Sòng bạc. Nếu không làm như vậy, có thể dẫn đến tất cả các khoản tín dụng tiền gửi sẽ bị giữ lại để điều tra thêm. Trong những trường hợp như vậy, PGEbet Casino có quyền loại bỏ phí xử lý bất kỳ lúc nào mà không cần thông báo của người chơi.'
    },
    {
      class: 't3',
      content: '14.5) Việc gửi tiền và sau đó rút tiền mặt mà không đặt cược sẽ không được chấp nhận. Sòng bạc có toàn quyền quyết định không cho phép xử lý giao dịch rút tiền. Quyết định của Sòng bạc là quyết định cuối cùng.'
    },
    {
      class: 't3',
      content: '14.6) PGEbet Casino có quyền yêu cầu Biểu mẫu ủy quyền bất kỳ lúc nào và có thể chấm dứt bất kỳ tài khoản nào không hoàn thành thỏa đáng và/hoặc trả lại Biểu mẫu ủy quyền trong một khoảng thời gian được PGEbet Casino xác định là hợp lý. Trong trường hợp như vậy, PGEbet Casino có thể đơn phương quyết định việc giải quyết bất kỳ khoản tiền tài khoản nào.'
    },
    {
      class: 't3',
      content: '14.7) Trong trường hợp tài liệu gian lận (nếu được yêu cầu), tài khoản sẽ bị khóa và tất cả tiền thắng cược và/hoặc tiền mặt sẽ vô hiệu.'
    },
    {
      class: 't3',
      content: '14.8) Tất cả các khoản tiền rút ra sẽ được kiểm toán trước khi xử lý. Bạn sẽ được thông báo qua email khi chúng tôi gửi tiền thắng cược của bạn. Việc rút tiền và các thay đổi đối với hướng dẫn thanh toán phải được Bộ phận An ninh của chúng tôi chấp thuận. Sòng bạc PGEbet có quyền trả tiền thắng cược cao hơn trong khoảng thời gian vài tuần theo hình thức trả góp.'
    },
    {
      class: 't3',
      content: '14.9) Khi tiền thưởng được đổi, việc đặt cược vào các trò chơi bị hạn chế sẽ bị cấm. Làm như vậy sẽ vô hiệu tiền thắng cược. Sòng bạc PGEbet có quyền giữ lại số tiền vượt quá số tiền gửi ban đầu của người chơi từ việc rút tiền của người chơi nếu tiền thưởng chơi được đặt vào các trò chơi bị hạn chế. Các phần thưởng khác nhau có các trò chơi bị hạn chế khác nhau và người chơi có trách nhiệm xem xét từng điều khoản và điều kiện cụ thể của phần thưởng đối với danh sách trò chơi bị hạn chế.'
    },
    {
      class: 't3',
      content: '14.10) PGEbet Casino có quyền từ chối hoặc hủy bỏ tiền thưởng chơi vì bất kỳ lý do gì bao gồm nhưng không giới hạn ở việc người chơi vi phạm. Trong trường hợp vi phạm, PGEbet Casino có quyền chấm dứt tư cách thành viên của người chơi và ngăn người chơi truy cập PGEbet Casino trong tương lai.'
    },
    {
      class: 't3',
      content: '14.11) Tiền thưởng sẽ chỉ được ghi có khi gửi tiền. Các khoản rút tiền hoàn lại không được coi là tiền gửi và sẽ không được kết hợp với tiền thưởng.'
    },
    {
      class: 't3',
      content: '14.12) Nếu bất kỳ khoản tiền gửi thực nào của người chơi vào Sòng bạc bị hoàn lại do không đủ tiền, khoản bồi hoàn hoặc bất kỳ lý do nào khác, bất kể phương thức thanh toán nào, Sòng bạc giữ quyền hủy bỏ khoản tiền thưởng, tín dụng, chiến thắng hoặc rút tiền. Tiền thưởng khi chơi sẽ chỉ được trao một lần cho mỗi gia đình và/hoặc mỗi tài khoản, theo điều khoản sử dụng của chúng tôi. Nếu tài khoản thứ hai được mở, tài khoản đó sẽ bị đóng và tất cả tiền thưởng chơi, tiền gửi và tiền thắng cược có thể bị hủy.'
    },
    {
      class: 't3',
      content: '14.13) Người chơi hoàn toàn biết thực tế rằng thẻ thanh toán/thẻ tín dụng của mình, khi được sử dụng để gửi tiền/mua hàng sẽ được lập hóa đơn ngay sau khi đặt cọc/mua hàng. Tất cả các khoản tín dụng THƯỞNG chỉ dành cho mục đích đặt cược. (Sẽ không được rút tiền với số tiền nhỏ hơn TIỀN THƯỞNG.) Theo yêu cầu rút tiền (bất kể số lượng tiền gửi), bất kỳ số tiền nào có giá trị tương đương với TIỀN THƯỞNG CHƠI sẽ bị trừ vào số dư chơi hoặc tiền thắng cược của bạn trước khi định cư. Các khoản tín dụng đầu tiên đã đặt cược sẽ được khấu trừ từ (các) khoản tiền gửi của bạn chứ không phải từ TIỀN THƯỞNG CHƠI.'
    },
    {
      class: 't3',
      content: '14.14) Bạn đồng ý rằng chúng tôi hoặc một công ty xử lý thanh toán (“Người xử lý thanh toán”) thay mặt chúng tôi sẽ xử lý tất cả các giao dịch tài khoản tài chính. Theo đây, bạn đồng ý rằng Bên xử lý thanh toán có quyền giữ lại bất kỳ khoản thanh toán nào nếu Bên xử lý thanh toán có lý do để tin tưởng hoặc bất kỳ nghi ngờ nào rằng bạn có thể đang tham gia hoặc đã tham gia vào hoạt động gian lận, thông đồng, bất hợp pháp hoặc không phù hợp.'
    },
    {
      class: 't3',
      content: '14.15) Bạn đồng ý thanh toán đầy đủ bất kỳ và tất cả các khoản thanh toán do chúng tôi hoặc bất kỳ bên thứ ba nào liên quan đến việc bạn sử dụng Sòng bạc Trực tuyến. Ngoài ra, bạn đồng ý không thực hiện bất kỳ khoản bồi hoàn nào và/hoặc từ bỏ hoặc hủy bỏ hoặc đảo ngược bất kỳ khoản thanh toán đến hạn nào của bạn và trong bất kỳ trường hợp nào như vậy, bạn sẽ hoàn lại và bồi thường cho chúng tôi các khoản thanh toán chưa thanh toán đó bao gồm mọi chi phí do chúng tôi phát sinh trong quá trình thu thanh toán của bạn.'
    },
    {
      class: 't3',
      content: '14.16) Chúng tôi hứa sẽ trả lời tất cả các câu hỏi trong vòng 1 ngày làm việc kể từ khi nhận được, bổ sung cho chức năng trò chuyện trực tiếp trong giờ làm việc.'
    },
    {
      class: 't3',
      content: '14.17) Bạn chỉ có thể sử dụng Sòng bạc Trực tuyến và / hoặc Trang web nếu bạn đủ tuổi hợp pháp theo quy định của pháp luật quốc gia nơi bạn sinh sống.'
    },
    {
      class: 't3',
      content: '14.18) Xin lưu ý: Bạn không thể sử dụng Sòng bạc Trực tuyến và / hoặc Trang web nếu bạn dưới 18 tuổi trong bất kỳ trường hợp nào.'
    },
    {
      class: 't3',
      content: '14.19) Xin lưu ý: Một số khu vực pháp lý đã không giải quyết tính hợp pháp của cờ bạc trực tuyến và những khu vực khác đặc biệt coi cờ bạc trực tuyến là bất hợp pháp. Chúng tôi không có ý định rằng bất kỳ ai nên sử dụng Sòng bạc Trực tuyến và/hoặc Trang web mà việc sử dụng đó là bất hợp pháp. Tính khả dụng của Sòng bạc Trực tuyến và/hoặc Trang web không tạo ra lời đề nghị hoặc lời mời của chúng tôi để sử dụng Sòng bạc Trực tuyến ở bất kỳ quốc gia nào mà việc sử dụng đó là bất hợp pháp. Bạn hoàn toàn chịu trách nhiệm về việc xác định xem việc sử dụng Sòng bạc Trực tuyến của bạn có hợp pháp ở quốc gia nơi bạn sinh sống hay không.'
    },
    {
      class: 't1',
      content: '15. Giới thiệu bạn bè'
    },
    {
      class: 't3',
      content: 'Bạn có thể xem Chương trình Giới thiệu Bạn bè hoặc Chương trình Liên kết trên phần Liên kết của trang web.'
    },
    {
      class: 't1',
      content: '16. Đóng tài khoản'
    },
    {
      class: 't3',
      content: '16.1) PGEbet không thể tự ý đóng tài khoản người dùng.'
    },
    {
      class: 't3',
      content: '16.2) Chúng tôi có quyền đóng tài khoản của bạn bất kỳ lúc nào vì bất kỳ lý do gì. Nếu chúng tôi chấm dứt tài khoản của bạn vì bất kỳ lý do gì, các điều khoản nêu dưới đây sẽ được áp dụng:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Bạn đồng ý rằng chúng tôi sẽ không chịu trách nhiệm với bạn về bất kỳ việc chấm dứt tài khoản hoặc việc bạn sử dụng Trang web;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Biện pháp khắc phục duy nhất của bạn trong trường hợp tài khoản của bạn bị chấm dứt là khoản hoàn trả cho số dư tài khoản không thể tranh cãi nào mà bạn có thể có khi đó và chúng tôi sẽ không có trách nhiệm pháp lý nào đối với bạn;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Trường hợp chúng tôi chấm dứt tài khoản của bạn do bạn vi phạm bất kỳ Điều khoản Sử dụng nào, chúng tôi có toàn quyền quyết định hủy bỏ mọi khoản tiền thắng cược và tịch thu mọi số dư. Những vi phạm như vậy bao gồm, nhưng không giới hạn ở:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn có nhiều tài khoản đang hoạt động (hoặc kiểm soát nhiều tài khoản đang hoạt động);'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Bạn đang vi phạm hoặc bất kỳ bảo đảm nào của bạn;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn đã mở một tài khoản đã bị chặn không thể mở tài khoản mới trong hệ thống của chúng tôi;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Chúng tôi bắt buộc phải tuân thủ các ràng buộc pháp lý và các quy định;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu tên trên tài khoản không trùng với tên trên phương thức thanh toán dùng để gửi tiền;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn cung cấp thông tin đăng ký không chính xác hoặc sai lệch;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn (chủ ý hoặc không) cho phép người khác chơi trên tài khoản của bạn;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn "thu hồi" bất kỳ khoản tiền gửi bằng thẻ thanh toán/tín dụng của bạn trên tài khoản;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn bị phát hiện gian lận, rửa tiền, hoặc thực hiện hành vi lừa đào;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu chúng tôi cho rằng bạn thuê người hoặc sử dụng hệ thống (bao gồm máy móc, máy tính, phần mềm hoặc hệ thống tự động khác) dùng để gian lận trên Casino;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu bạn có lời lẽ thô tục, xúc phạm trên công cụ nhắn tin hoặc với bất kỳ nhân viên của chúng tôi, bao gồm các hành vi phân biệt chúng tộc, thù hận, hoặc xúc phạm;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Việc sử dụng robot, máy móc, thiết bị điện tử hoặc thiết bị khác để tự động ra quyết định trong các trò chơi (không có sự cho phép của chúng tôi); hoặc'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Nếu chúng tôi phát hiện bạn đã chơi ở các Online Casino khác với mục đích xấu hoăc trong các trường hợp kể trên;'
    },
    {
      class: 't3',
      content: '17.3) Khi tài khoản bị khoá, bạn đồng ý và hiểu rằng các quyền sử dụng Online Casino sẽ bị chấm dứt và bạn phải xoá cac phần mềm dành cho bạn hoặc tải xuống từ website;'
    },
    {
      class: 't1',
      content: '17. Lừa đảo'
    },
    {
      class: 't3',
      content: '17.1) Chúng tôi có quyền giữ thanh toán cho bạn khi bạn bị nghi ngờ tham gia các hoạt động gian lận, hoặc phạm tội;'
    },
    {
      class: 't3',
      content: '17.2) Bạn sẽ được bồi thường và phải chịu trách nhiệm phải trả cho chúng tôi, theo yêu cầu, tất cả các chi phí, phí hoặc lỗ duy trì hoặc phát sinh bởi chúng tôi (bao gồm bất kỳ tổn thất trực tiếp, gián tiếp hoặc do hậu quả nào, mất lãi và mất danh tiếng) phát sinh trực tiếp hoặc gián tiếp từ gian lận của bạn , không trung thực hoặc hành vi phạm tội;'
    },
    {
      class: 't1',
      content: '18. Tranh chấp và khiếu nại'
    },
    {
      class: 't3',
      content: '18.1)Bất kỳ sự leo thang của một cuộc điều tra khách hàng về nhóm khiếu nại sẽ được phân loại là một "khiếu nại". Xin lưu ý rằng bất kỳ cuộc gọi nào đến nhóm hỗ trợ khách hàng của chúng tôi hoặc các nhà quản lý / giám sát viên của chúng tôi có thể được theo dõi hoặc ghi lại cho mục đích đào tạo và quản lý chất lượng và hỗ trợ chúng tôi trong việc giải quyết nhanh chóng và hiệu quả của các thắc mắc khách hàng.'
    },
    {
      class: 't3',
      content: '18.2) Chúng tôi sẽ không chịu đựng bất kỳ ngôn ngữ hoặc hành vi hoặc hành vi tấn công nào gây khó chịu, đe dọa hoặc tấn công khác đối với các thành viên của nhân viên.'
    },
    {
      class: 't3',
      content: '18.3) Có câu hỏi khác, vui lòng liên hệ support@pgebet.com'
    }
  ],
  faqList: [
    {
      key: 'chung',
      label: 'Các câu hỏi thường gặp'
    },
    {
      key: 'tài khoản',
      label: 'Tài khoản'
    },
    {
      key: 'thưởng',
      label: 'Tiền thưởng và Khuyến mại'
    },
    {
      key: 'gửi tiền',
      label: 'Tiền gửi'
    },
    {
      key: 'rút tiền',
      label: 'Tiền rút ra'
    },
    {
      key: 'đặt cược',
      label: 'Yêu cầu đặt cược'
    },
    {
      key: 'hỗ trợ',
      label: 'Hỗ trợ kỹ thuật'
    }
  ],
  faqDetailList: {
    common: [
      {
        subTitle: 'Làm thế nào để nạp tiền',
        content:
          '<div style="margin-bottom: 10px;">Đăng nhập tài khoản và hoàn thành các bước sau:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Nhấn chuột vào nút "NẠP TIỀN".</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Nhập số tiền muốn nạp</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Nhấn "XÁC NHẬN"</div>' +
          '<div style="margin-top: 10px;">Bắt đầu chơi.</div>'
      },
      {
        subTitle: 'Số tiền nạp tối thiểu?',
        content: '<div>Số tiền tối thiểu là 100 INR và tối đa 50,000 INR mỗi giao dịch.</div>'
      },
      {
        subTitle: '3D Secure là gì?',
        content:
          '<div>Trước khi nạp tiền, hệ thống xác thực chủ thẻ bằng cách chuyển hướng chủ thẻ sang trình duyệt của ngân hàng đã cấp thẻ.</div>' +
          '<div style="margin-top: 10px;">Khi giao dịch trực tuyến với 3D Secure, bạn sẽ được chuyển hướng đến một trang web từ nhà phát hành thẻ của mình, yêu cầu bạn nhập mã PIN hoặc Mật khẩu của bạn.</div>'
      },
      {
        subTitle: 'Tiền gửi của tôi sẽ nhanh chóng được ghi có vào tài khoản của mình như thế nào?',
        content:
          '<div>Quá trình diễn ra ngay lập tức.</div>'
      },
      {
        subTitle: 'Số tiền nạp không được hiển thị trên tài khoản?',
        content:
          '<div>Điều đầu tiên cần làm là làm mới trang của bạn. Nếu số tiền ký gửi vẫn chưa được ghi có, vui lòng liên hệ với nhóm Livesupport của chúng tôi và một trong những đại diện của chúng tôi sẽ có thể giúp bạn.</div>' +
          '<div style="margin: 10px 0;">Vui lòng cung cấp các thông tin sau:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Bạn đã dùng phương thức nạp tiền nào?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Bạn nạp tiền khi nào?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Số tiền nạp bao nhiêu? </div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Ngân hàng bạn sử dụng?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Số tiền nạp đã bị trừ vào tài khoản thanh toán của bạn chưa? Nếu có, vui lòng cung cấp ảnh chụp màn hình/số dư tài khoản.</div>'
      },
      {
        subTitle: 'Tôi có thể tìm lịch sử nạp tiền ở đâu?',
        content:
          '<div>Để xem thông tin này, chỉ cần nhấp vào nút Tài khoản / Lịch sử. Ở đây bạn có thể xem tất cả các khoản tiền gửi trong quá khứ của bạn được thực hiện.</div>'
      }
    ],
    account: [
      {
        subTitle: 'Tôi tạo tài khoản như thế nào?',
        content:
          '<div> Đăng ký và tạo tài khoản, nhập số điện thoại của bạn và làm theo các bước nhanh chóng và đơn giản.</div>'
      },
      {
        subTitle: 'Tôi không thể tạo một tài khoản mới, vì một tài khoản đã được tạo từ thiết bị này, tôi phải làm gì?',
        content:
          '<div>Đảm bảo rằng bạn không có tài khoản với chúng tôi. Hãy nhớ rằng chúng tôi chỉ cho phép một tài khoản cho mỗi người chơi. Nếu bạn đã tạo một tài khoản với chúng tôi trong quá khứ, chúng tôi vui lòng yêu cầu bạn chơi trên tài khoản hiện tại của bạn.</div>' +
          '<div style="margin-top: 10px;">Nếu bạn không thể nhớ chi tiết đăng nhập của mình, vui lòng làm theo các hướng dẫn khôi phục mật khẩu. Nếu bạn chưa bao giờ đăng ký tài khoản, nhưng thông tin đăng nhập tài khoản của bạn đã tồn tại trong cơ sở dữ liệu của chúng tôi, vui lòng liên hệ với nhóm hỗ trợ trực tiếp của chúng tôi để chúng tôi có thể xem xét thêm.</div>'
      },
      {
        subTitle: 'Xem số dư ở đâu?',
        content:
          '<div>Số dư được hiển thị ở góc giữa trên cùng.</div>'
      }
    ],
    bonus: [
      {
        subTitle: 'Tôi tìm các chương trình khuyến mại và thưởng như thế nào?',
        content:
          '<div>Bạn có thể tìm thấy tất cả các chương trình khuyến mãi hiện tại trên trang khuyến mãi. Thỉnh thoảng, chúng tôi gửi thông báo khi chúng tôi có một quảng cáo để bạn tham gia. Bạn cũng có tùy chọn để từ chối các thông báo này nếu bạn không muốn nhận chúng lâu hơn.</div>'
      },
      {
        subTitle: 'Thưởng được tính như thế nào? Tiền thưởng 100% số tiền nạp là gì?',
        content:
     '<div> PGBET cung cấp nhiều phần thưởng có thể được trao cho tài khoản của bạn. Phân bổ tiền thưởng là những ưu đãi được trao cho bạn dựa trên hoạt động trên trang web của chúng tôi. Thỉnh thoảng chúng tôi sẽ gửi cho bạn các chương trình khuyến mãi tiền thưởng có thể bao gồm tiền thưởng tiền gửi và các chương trình khuyến mãi trò chơi khác. </ Div> ' +
           '<div style = "Margin-top: 10px;"> Hiện tại chúng tôi cung cấp tiền thưởng 100% tiền gửi. Điều này có nghĩa là một khoản tiền gửi 100 INR sẽ nhận thêm 100 INR tiền thưởng, tạo số dư người chơi 200 INR. Xin lưu ý rằng người dùng sau đó sẽ phải tuân theo các yêu cầu đặt cược. </ Div> '
      },
      {
        subTitle: 'Tôi nhận tiền thưởng như thế nào',
        content:
          '<div>để tìm phần thưởng của bạn, nhấp vào nút "Tài khoản" và trong menu mở ra, số tiền thưởng của bạn sẽ tự động được hiển thị. Chọn Yêu cầu Một khi bạn đã hoàn tất yêu cầu đặt cược để bạn có thể chuyển đổi số tiền thưởng thành tài khoản tiền mặt của mình</div>'
      },
      {
        subTitle: 'Tiền thưởng hoàn lại tiền mặt là gì?',
        content:
          '<div>Tiền thưởng hoàn lại tiền là phần thưởng tiền tệ đại diện cho một số tiền gửi nhất định đã được đưa vào các trò chơi, mà bạn có thể yêu cầu quay lại trong ví của mình, không có yêu cầu đặt cược.</div>'
      },
      {
        subTitle: 'Vòng quay may mắn miễn phí',
        content:
       '<div> Ví dụ bạn được trao 50 vòng quay miễn phí. Bằng cách đó, bạn có khả năng phát 50 vòng quay trên các trò chơi đặc trưng mà không cần bất kỳ khoản tiền thực tế nào trong số dư tài khoản của bạn. </ Div> ' +
          '<div style = "Margin-top: 10px;"> Trong trường hợp có bất kỳ khoản tiền thưởng nào được tạo từ các vòng quay miễn phí, chúng sẽ được ghi có vào tài khoản của bạn dưới dạng tiền thưởng và sẽ tuân theo các điều khoản và điều kiện tiêu chuẩn, Điều khoản thưởng và yêu cầu đặt cược của chúng tôi . Tuy nhiên, một khi các yêu cầu đặt cược hoặc các yêu cầu chơi thông qua được hoàn thành, tiền thắng được coi là tiền thật và có sẵn để rút tiền. </ Div> '
      },
      {
        subTitle: 'Tiền thưởng có hết hạn không?',
        content:
          '<div>Tiền thưởng có giá trị trong bảy (7) ngày, vì vậy mọi yêu cầu đặt cược hiện tại phải được hoàn thành trong khung thời gian đó; nếu không thì số dư tiền thưởng sẽ bị hủy</div>'
      }
    ],
    deposit: [
      {
        subTitle: 'Tôi nạp tiền như thế nào?',
        content:
        '<div style = "maggin-bottom: 10px;"> Đăng nhập vào tài khoản của bạn và hoàn thành các bước sau: </ div>' +
          '<div style = "margin-left: 15px; display: flex"> <i> 1. & nbsp; </i> nhấp vào nút "Gửi tiền". </ div>' +
          '<div style = "margin-left: 15px; display: flex"> <i> 2. & nbsp; </i> nhập số tiền ký gửi </ div>' +
          '<div style = "margin-left:  15px; display: flex"> <i> 3. & nbsp; </i> nhấp vào "Gửi" </div>' +
          '<div style = "Margin-top: 10px;"> sau đó bắt đầu chơi các trò chơi yêu thích của bạn. </div>'
      },
      {
        subTitle: 'Số tiền nạp tối thiểu',
        content: '<div>Số tiền nạp tối thiểu là 100 INR và tối đa là 50,000 INR mỗi giao dịch.</div>'
      },
      {
        subTitle: '3D Secure hoạt động như thế nào?',
        content:
          '<div>Trước khi ký gửi có thể được thực hiện, hệ thống xác thực chủ thẻ bằng cách chuyển hướng chủ thẻ sang trình duyệt của ngân hàng đã cấp thẻ. </Div> ' +
           '<div style = "margin-top: 10px;"> Khi bạn thực hiện giao dịch trực tuyến với Secure 3D, bạn đã chuyển hướng đến một trang web từ nhà phát hành thẻ của mình, yêu cầu bạn nhập mã PIN hoặc MẬT KHẨU của bạn.</div>'
      },
      {
        subTitle: 'Bao giờ tiền nạp vào tài khoản?',
        content:
          '<div>Thời gian xử lý bắt đầu từ lúc này..</div>'
      },
      {
        subTitle: 'Tiền gửi không được chuyển về tài khoản của tôi?',
        content:
          '<div>Đầu tiên bạn cần tải lại trang. Nếu số tiền gửi không hiển thị, vui lòng liên hệ đội ngũ Hỗ trợ trực tiếp, và một trong những đại diện của chúng tôi sẽ hỗ trợ bạn.</div>' +
          '<div style="margin: 10px 0;">Vui lòng chuẩn bị một số thông tin sau:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Bạn sử dụng phương pháp chuyển tiền nào?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Bạn đã gửi tiền lúc nào?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Bạn đã gửi bao nhiêu tiền?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Bạn sử dụng ngân hàng nào?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Tiền đã được rút từ tài khoản mà bạn đã gửi tiền chưa? Nếu vậy, vui lòng cung cấp ảnh chụp màn hình của giao dịch / bảng sao kê ngân hàng.</div>'
      },
      {
        subTitle: 'Tôi có thể tìm lịch sử gửi tiền của mình ở đâu?',
        content:
          '<div>Để xem thông tin này, chỉ cần nhấp vào nút Tài khoản / Lịch sử. Tại đây bạn có thể xem tất cả các khoản tiền gửi trước đây của mình.</div>'
      }
    ],
    withdraw: [
      {
        subTitle: 'Tôi có thể rút số dư tiền thưởng của mình không?',
        content:
          '<div>Không thể rút số dư tiền thưởng nếu các yêu cầu đặt cược chưa được đáp ứng.</div>'
      },
      {
        subTitle: 'Làm cách nào để rút tiền?',
        content:
          '<div>Để thực hiện yêu cầu rút tiền, nhấp vào nút "Rút tiền" và làm theo các bước. Để thực hiện yêu cầu rút tiền, nhấp vào nút "Rút tiền" và làm theo các bước.</div>'
      },
      {
        subTitle: 'Tôi có thể rút bao nhiêu?',
        content:
          '<div>Số tiền rút tối thiểu là 500 INR. Số tiền rút tối đa là 50.000 INR cho mỗi giao dịch. Không có giới hạn về số tiền có thể được rút.</div>'
      },
      {
        subTitle: 'Khi nào tôi có thể rút tiền?',
        content:
          '<div>Bạn có thể rút từ 9 giờ sáng - nửa đêm theo giờ IST (Thứ Hai đến Thứ Sáu). Nếu bạn muốn rút tiền sau những giờ này, vui lòng liên hệ với Bộ phận hỗ trợ.</div>' +
          '<div>Việc rút tiền được xử lý ngay lập tức nhưng có thể mất 24 - 48 giờ tùy thuộc vào ngân hàng của bạn. Đối với hầu hết các ngân hàng, việc rút tiền được thực hiện ngay lập tức và ngay trong ngày.</div>'
      }
    ],
    wagering: [
      {
        subTitle: 'Yêu cầu đặt cược là gì?',
        content:
          '<div>Yêu cầu đặt cược như nó thường được gọi là số tiền giá trị bạn cần đặt cược để số dư tiền thưởng của bạn chuyển đổi thành tín dụng tiền thật và đủ điều kiện để rút. Ví dụ: Nếu người chơi gửi ₹1.000 với 100% Tiền thưởng và tiền thưởng đó có mức cược 80X, điều đó có nghĩa là số dư tiền thưởng được ghi có vào tài khoản của bạn (₹1,000) sẽ cần được đặt cược hoặc chơi 80X (80 lần) số dư tiền thưởng.</div>' +
          '<div style="margin-top: 10px;"> Gửi ₹1,000 trong chương trình thưởng 100% = ₹1,000</div>' +
          '<div style="margin-top: 10px;">Trong trường hợp này, ₹1,000 X 80 là yêu cầu đặt cược = ₹80,000</div>' +
          '<div style="margin-top: 10px;">Sau khi bạn đã chơi đủ 80X số dư tiền thưởng(lượt quay/cá cược trị giá ₹80,000), tiền thưởng của bạn sẽ chuyển thành ví chính của bạn và bạn đủ điều kiện để rút tiền của mình.</div>' +
          '<div style="margin-top: 10px;">Để biết thêm thông tin, hãy xem trang điều khoản và điều kiện của chúng tôi.</div>'
      },
      {
        subTitle: 'Tôi có thể hủy hoặc chọn không tham gia đặt cược không?',
        content:
          '<div>Bạn không thể hủy đặt cược của mình sau khi đã kích hoạt, tuy nhiên tại PGEbet, chúng tôi đảm bảo rằng người chơi có thể "chọn không tham gia" đặt cược và chuyển đổi số dư tiền thưởng thành số dư ví chính của họ.</div>'
      },
      {
        subTitle: 'Điều gì xảy ra khi tôi chọn không tham gia đặt cược?',
        content:
          '<div>Trên trang "Tài khoản", bạn có thể theo dõi yêu cầu đặt cược của mình trong thời gian thực. Sẽ có một% cược hoàn thành nếu bạn đã chơi. Tỷ lệ hoàn thành đặt cược đó là% số tiền thực sẽ chuyển đổi sang ví chính của bạn khi bạn chọn không tham gia.</div>'
      }
    ],
    support: [
      {
        subTitle: 'Điều gì xảy ra nếu trò chơi bị đóng băng giữa một vòng?',
        content:
          '<div>Nếu trò chơi của bạn bị đóng băng bất kỳ lúc nào, bạn sẽ kết thúc chính xác nơi bạn đã dừng lại vào lần tiếp theo khi bạn mở trò chơi. Nếu bạn không có tùy chọn nào để làm như vậy, vòng chơi sẽ được hoàn thành trên máy chủ ngay cả khi máy tính của bạn bị đóng băng hoặc kết nối Internet ngừng hoạt động. Mọi khoản tiền thắng cược đều được trả vào tài khoản của bạn như bình thường.</div>'
      },
      {
        subTitle: 'Vì sao trò chơi chậm vậy?',
        content:
          '<div>MĐảm bảo rằng bạn đã cài đặt phiên bản trình duyệt mới nhất (chúng tôi khuyên bạn nên sử dụng Google Chrome) và phiên bản Flash mới nhất. Ngoài ra, hãy đảm bảo rằng đó không phải là vấn đề kết nối Internet (hãy thử sử dụng cáp mạng nếu kết nối không dây không hoạt động như bình thường) và đóng bất kỳ chương trình nền nào có thể làm tiêu hao băng thông của bạn.</div>'
      },
      {
        subTitle: 'Tại sao trò chơi của tôi không tải?',
        content:
          '<div>Điều này có thể có nghĩa là bạn đã mất liên lạc với máy chủ. Hãy thử đăng xuất và đăng nhập lại và thử lại. Đôi khi bạn có thể cần phải tắt trình duyệt và bắt đầu lại để tải trò chơi. Nếu sự cố vẫn tiếp diễn, vui lòng liên hệ với nhóm Hỗ trợ trực tiếp của chúng tôi và một trong những đại diện của chúng tôi sẽ có thể trợ giúp.</div>'
      },
      {
        subTitle: 'Tôi phải làm gì nếu không thể mở trò chơi?',
        content:
          '<div>Nếu bạn nhận được thông báo lỗi khi cố gắng mở trò chơi, hãy liên hệ với nhóm Hỗ trợ Trực tiếp của chúng tôi và một trong những đại diện của chúng tôi sẽ có thể giúp bạn.</div>'
      }
    ]
  },
  aboutUs: [
    {
      class: 't2',
      content: 'Chúng tôi tự hào là một trong những Sòng bạc Trực tuyến phổ biến nhất ở Ấn Độ và Châu Á. Chúng tôi tự hào hơn với mục tiêu trở thành Sòng bạc Trực tuyến đáng tin cậy và an toàn nhất, cung cấp giải trí chơi game đỉnh cao cho người chơi của chúng tôi. Trò chơi của chúng tôi rất vui, thú vị và thực sự nhập vai. Giống như đang chơi ở một Sòng bạc ngoài đời thực!'
    },
    {
      class: 't2',
      content: '<span style="font-weight: bold">Công bằng, An toàn và Bảo mật</span>'
    },
    {
      class: 't2',
      content: 'Tại PGEbet, bạn được đảm bảo một môi trường Casino trực tuyến công bằng, an toàn và bảo mật.'
    },
    {
      class: 't2',
      content: 'Chúng tôi làm việc 365 ngày một năm và Nhóm hỗ trợ khách hàng của chúng tôi luôn ở đây để đảm bảo thời gian của bạn với chúng tôi không gặp rắc rối và thú vị nhất có thể.'
    },
    {
      class: 't2',
      content: 'Vì vậy, hãy khám phá trải nghiệm đỉnh cao trong giải trí chơi game trực tuyến. Chúng tôi tin tưởng rằng PGEbet sẽ là nơi yêu thích của bạn để đặt cược trực tuyến. Chúng tôi chào đón tất cả những người chơi đủ điều kiện từ khắp nơi trên thế giới.'
    }
  ],
  userGuide: {
    homePrompt: 'Chơi các trò chơi phổ biến nhất của chúng tôi',
    depositPrompt: 'Tiền gửi nhanh chóng. Các tùy chọn khác nhau có sẵn.',
    withdrawPrompt: 'Rút tiền mọi lúc.',
    supportPrompt: 'Hỗ trợ Trực tuyến từ 9 giờ sáng - đêm.',
    giftPrompt: 'Hãy gửi tiền trong 24 giờ tới và nhận phần thưởng 1500 Rupee tiền mặt miễn phí để chơi cùng. Chuyển đến nút Gửi tiền để gửi tiền.',
    bonusDepositPrompt1: 'Đặt cọc 100 Rupee và nhận phần thưởng 150 Rupee.',
    bonusDepositPrompt2: 'Đặt cọc 500 Rupee và nhận phần thưởng 750 Rupee.',
    bonusDepositPrompt3: 'Đặt cọc 1000 Rupee và nhận phần thưởng 1500 Rupee.'
  },
  loadingStatus: {
    pullToLoad: 'kéo xuống để tải thêm',
    releaseToLoad: 'kéo xuống để tải thêm',
    loading: 'đang tải'
  },
  home: {
    gameMaintenancePrompt: 'Trò chơi này hiện đang được bảo trì. Nó sẽ được mở trở lại trong giây lát. Vui lòng quay lại sau.'
  },
  /***
   * 2021-10-10 C007 gift is not used any more, please use deposit gift & daily gift instead
   * **/
  gift: {
    prompt: 'Hãy gửi tiền trong 24 giờ tới và nhận phần thưởng 1500 Rupee tiền mặt miễn phí để chơi cùng. Vào nút Gửi tiền để thực hiện gửi tiền.',
    rule1: 'Đặt cọc 100 Rupee và nhận phần thưởng 150 Rupee.',
    rule2: 'Đặt cọc 500 Rupee và nhận phần thưởng 750 Rupee.',
    rule3: 'Đặt cọc 1000 Rupee và nhận phần thưởng 1500 Rupee.'
  },
  depositGift: {
    textExtra: 'Tặng thêm những ưu đãi hấp dẫn cho lần nạp tiền đầu tiên',
    text24Hours: '24 giờ sau khi đăng ký'
  },
  sevenDayGift: {
    textComeBack: 'QUAY LẠI',
    textEveryday: 'MỖI NGÀY ĐỂ NHẬN TIỀN MIỄN PHÍ',
    btnDeposit: 'Gửi tiền',
    btnCollect: 'Nhận ngay!',
    btnNextCash: 'TIỀN MIỄN PHÍ TIẾP THEO TRONG'
  },
  history: {
    status: 'tình trạng'
  },
  landing1: {
    text11: 'Hãy đặt cược với',
    text12: 'PGEbet',
    text21: 'Sòng bạc trực tuyến tốt nhất',
    text22: 'Ấn Độ',
    text31: 'Đăng nhập để nhận',
    text32: '₹100 ngay',
    text33: 'phần thưởng',
    text41: 'Lên tới',
    text42: '10,000x',
    text43: 'Tiền thắng cược'
  },
  landing2: {
    text1: 'Hãy đặt cược với',
    text2: 'PGEbet',
    text3: 'Sòng bạc trực tuyến và nổi tiếng nhất',
    text4: 'Ấn Độ và châu Á',
    text5: 'Đăng nhập để nhận ngay',
    text6: '₹100 phần thưởng',
    text7: 'và nhiều phần thưởng khác. Lên tới',
    text8: '10,000x',
    text9: 'Tiền thắng',
    contact: 'Kết nối với chúng tôi',
    pgeBet: 'PGEbet',
    forAndroid: 'Ứng dụng PGEbet có mặt trên Android.'
  },
  download: {
    textYou: 'Bạn thật Tuyệt!',
    textDownload: 'Tải ứng dụng và chơi',
    textPlace: 'Đặc cược tại',
    textTheBest: 'Sòng bạc trực tuyến tốt nhất',
    textCountry: 'Ấn Độ',
    textLogin: 'Đăng nhập để nhận',
    textInstant: '₹100 ngay',
    textGift: 'phần thưởng',
    textUpto: 'Lên tới',
    text10000x: '10,000x',
    textWinning: 'Tiền thắng cươcj',
    betWithPGEbet: 'Đặt cược với PGEbet',
    slogan: 'Trang web cược trực tuyến số 1 Việt Nam. Đăng nhập ngay bây giờ để nhận quà tặng tức thì và các phần thưởng khác.',
    downloadTip1: 'Có sẵn trên Android. Đi tới',
    downloadTip2: 'để tải xuống.',
    android: 'Android',
    scan: 'Quét mã QR để tải xuống Ứng dụng PGEbet Android'
  },
  share: {
    textCongratulation: 'Chúc mừng!',
    textPlace: 'Đặc cược tại',
    textTheBest: 'Sòng bạc tốt nhất Ấn Độ',
    textRegisterNow: 'Đăng ký ngay đẻ nhận ngay phần thưởng ₹100',
    textUpto: 'Lên tới 10,000x Tiền thắng cược',
    btnStart: 'Bắt đầu'
  },
  versionUpdate: {
    textNewVersion: 'Phiên bản mới của PGEbet đã có sẵn. Bạn sẽ cần tải xuống và cài đặt phiên bản mới nhất của tệp APK để trải nghiệm các tính năng mới nhất.',
    textPleaseUpgrade: 'Vui lòng nâng cấp lên phiên bản mới nhất của Ứng dụng PGEbet để có thể sử dụng cổng thanh toán này.',
    btnClickToDownload: 'Nhấp để tải xuống ngay',
    textCopyLnk: 'Hoặc sao chép liên kết bên dưới và dán vào trình duyệt của bạn để tải xuống',
    btnCopyLnk: 'Sao chép liên kết'
  },
  copyRight: 'India: E-30 Fourth Floor, Sector 3, Noida - 201301. © 2022 PGEbet all rights reserved. DM Global Ltd (Company): Eden Island, Mahe, Seychelles.',
  news: {
    readMore: 'Đọc thêm'
  },
  gameCompetition: {
    ranking: 'Xếp hạng',
    howToPlay: 'Cách chơi',
    rules: [
      'Thời gian diễn ra cuộc thi: 1 Tháng Hai 2022 - 30 Tháng Tư 2022',
      'Mỗi cá cược trị giá ₹100 tính là 1 điểm.',
      'Người chơi có số điểm cao nhất trong tháng nhận: ₹300,000 tiền thưởng.',
      'Mỗi người chơi có số điểm xếp thứ 2 - thứ 10 trong tháng nhận: ₹50,000 tiền thưởng.',
      'Mỗi người chơi có số điểm xếp thứ 11 - thứ 20 trong tháng nhận: ₹10,000 tiền thưởng.',
      'Mỗi người chơi có số điểm xếp thứ 21 - thứ 50 trong tháng nhận: ₹5,000 tiền thưởng.',
      'Mỗi người chơi có số điểm trong tháng trên 100 nhưng không nằm trong top 50: ₹100 tiền thưởng.',
      'Điểm số và thứ hạng được cập nhật hàng ngày lúc 3 giờ chiều.',
      'Điểm số được đặt lại vào ngày đầu tiên của mỗi tháng trong suốt thời gian diễn ra cuộc thi.',
      'Giải thưởng được ghi có trong vòng 5 ngày đầu của tháng.'
    ]
  },
  wagering: {
    title: 'Thưởng',
    promptAll: 'Các trò chơi khác không được liệt kê sẽ có yêu cầu đặt cược là 300X',
    promptFollowing: 'Các trò chơi sau không trong danh sách Tiền thưởng:',
    name: 'Tên',
    provider: 'Nhà cung cấp',
    wagering: 'Cá cược'
  },
  // 2022-03-10 CHP Bonus页面
  bonus: {
    expire: 'hết hạn khi',
    received: 'đã nhận',
    completed: 'đã hoàn thành',
    claimed: 'đã lấy',
    unclaimed: 'chưa lấy',
    noDataAvailable: 'không có dữ liệu'
  },
  // 2022-03-13 CHP 召回
  callback: {
    welcome: 'chào mừng bãn quay lại!',
    loyal: 'khách hàng kim cương sẽ nhận tiền thưởng khi kết thúc',
    getitnow: 'Lấy ngay!'
  },
  // 2022-03-17 CHP Bonus活动
  bonusActivity: {
    holi: {
      dailyGoal: 'mục tiêu hàng ngày',
      bet: 'đặt',
      bonus: 'thêm',
      introduction: 'Tiền thưởng thêm lên đến ₹ 100.000 trong Lễ hội Holi! Nhận tiền thưởng của bạn ngay lập tức sau khi đạt được mục tiêu cá cược. Chọn Mục tiêu hàng ngày 1,2 hoặc 3 để giành chiến thắng!',
      howDoesTitle: 'nó hoạt động như thế nào?',
      howDoesItems: [
        'Thời gian khuyến mãi: 18 tháng 3 đến 24 tháng 3 năm 2022.',
        'Bạn có thể chọn một trong ba Mục tiêu Hàng ngày ở trên.',
        'Sau khi hoàn thành yêu cầu đặt cược cho Mục tiêu hàng ngày đã chọn cho ngày hiện tại, bạn có thể nhận tiền thưởng tương ứng.',
        'bạn chỉ có thể chọn một mục tiêu cho 1 ngày .',
        'Mục tiêu Hàng ngày sẽ đặt lại lúc 00:00 sáng hàng ngày và bạn phải hoàn thành trước 00:00 sáng ngày hôm sau để nhận tiền thưởng.'
      ],
      confirmSelect: 'Bạn có thể vui lòng xác nhận mục tiêu đã chọn của mình không? Bạn sẽ không thể thay đổi lựa chọn của mình sau đó',
      eventEnd: 'sự kiện đã kết thúc',
      hasCollectedBonus: 'Bạn đã lấy tiền thưởng.',
      notEligible: 'Bạn không đủ điều kiện để tham gia sự kiện này.',
      notCompleted: 'Mục tiêu hàng ngày bạn đã chọn vẫn chưa được hoàn thành.',
      selectGoal: 'Hãy chọn mục tiêu hàng ngày 1,2 hoặc 3',
      collect: 'lấy',
      notParticipate: 'Bạn không tham gia sự kiện này.'
    }
  },
  // 2022-03-17 CHP MessageBox
  messageBox: {
    confirm: 'xác nhận',
    ok: 'Ok',
    cancel: 'Huỷ'
  }
}



// WEBPACK FOOTER //
// ./src/assets/locale/vi-VN.js